<template>
  <div class="logisContainer">
    <div class="mapContainer" v-loading="isMapLoading" ref="mapContainer">
      <transition name="el-zoom-in-top">
        <!-- <div class="toolsBox" v-show="isMapToolBarShow"> -->
        <div class="fl" v-show="isMapToolBarShow">
          <div class="tool-span">
            <e6-city
              :label="map_city"
              :format="['省', '市']"
              placeholder="切换城市"
              @selected="changeMapCity"
            ></e6-city>
            <i class="e6-icon-arrow-b_fill"></i>
          </div>
        </div>
        <!-- </div> -->
      </transition>
      <transition name="el-zoom-in-top">
        <div class="fr" v-show="isMapToolBarShow">
          <!-- 智能搜索 -->
          <!-- <div class="intelligent">
            <el-input
              size="mini"
              placeholder="智能搜索"
              class="searchBox"
              v-model="intelligent.searchTxt"
              @keydown.native.enter="search_intelligent"
            >
              <i
                slot="suffix"
                class="e6-icon-search_line"
                @click="search_intelligent"
                title="搜索"
              ></i>
            </el-input>
          </div> -->
          <div class="tool-span">
            <!-- 物流地图 -->
            <el-popover
              placement="bottom-start"
              transition="zoom-in-top"
              width="150"
              popper-class="mapDropdown"
              trigger="click"
              v-model="logisShow"
            >
              <ul>
                <li>
                  <span><i class="e6-icon-area_line"></i>区域</span>
                  <span>
                    <i
                      v-show="mapAuthData.物流地图.自定义点及区域管理.add"
                      class="e6-icon-add_line"
                      title="添加"
                      @click="openMarkTypeLayer(false)"
                    ></i>
                  </span>
                </li>
                <li>
                  <span>
                    <i class="e6-icon-administrative-area_line"></i>行政区域
                  </span>
                  <span>
                    <i
                      v-show="mapAuthData.物流地图.自定义点及区域管理.add"
                      class="e6-icon-add_line"
                      title="添加"
                      @click="markOverlay('areaXz')"
                    ></i>
                  </span>
                </li>
              </ul>
              <span class="toolBtn" slot="reference">
                <i class="e6-icon-map_line"></i>物流地图
                <i class="e6-icon-arrow-b_fill"></i>
              </span>
            </el-popover>
          </div>
          <!-- 全屏切换 -->
          <el-tooltip
            class="item"
            effect="dark"
            :hide-after="2000"
            transition="el-zoom-in-bottom"
            :content="isFullScreen ? '退出全屏' : '全屏'"
            placement="bottom"
          >
            <span class="tool-span" @click="fullScreenChange">
              <i
                :class="[
                  'full-screen',
                  isFullScreen
                    ? 'e6-icon-screen-half_line'
                    : 'e6-icon-screen-full_line'
                ]"
              ></i>
            </span>
          </el-tooltip>
        </div>
        <!-- </div> -->
      </transition>
      <!-- <el-amap vid="amapContainer"></el-amap> -->
      <!-- <div id="myalert" style="display:none;"></div> -->
      <div
        id="amapContainer"
        ref="amapContainer"
        :style="{
          width: mapContainer_wh.width + 'px',
          height: mapContainer_wh.height + 'px'
        }"
      ></div>
      <!-- 智能搜索 -->
      <!-- <e6-box
        class="editLayer intelligentLayer"
        ref="moreLayer_intelligent"
        title="智能搜索"
        @closeFun="closeMoreLayer_intelligent"
      >
        <el-tabs
          class="intelligent-tab"
          tab-position="left"
          ref="intelligentTab"
          :value="intelligentShowTabName"
          @tab-click="tabChange"
        >
          <el-tab-pane label="车辆" name="vehicle">
            <ul class="content" v-show="!intelligentShow('vehicle')">
              <li
                v-for="(sItem, index) in intelligent.result['vehicle']"
                :key="sItem.id + sItem.name"
                @click="showDetails_intelligent('vehicle', sItem.id)"
              >
                <h3>{{ index + 1 }}</h3>
                <span class="title" :title="sItem.name">{{ sItem.name }}</span>
                <span class="address" :title="sItem.address">{{
                  sItem.address
                }}</span>
              </li>
            </ul>
          </el-tab-pane>
          <el-tab-pane label="点" name="marker">
            <ul class="content" v-show="!intelligentShow('marker')">
              <li
                v-for="(sItem, index) in intelligent.result['marker']"
                :key="sItem.id + sItem.name"
                @click="showDetails_intelligent('marker', sItem.id)"
              >
                <h3>{{ index + 1 }}</h3>
                <span class="title" :title="sItem.name">{{ sItem.name }}</span>
                <span class="address" :title="sItem.address">{{
                  sItem.address
                }}</span>
              </li>
            </ul>
          </el-tab-pane>
          <el-tab-pane label="区域" name="area">
            <ul class="content" v-show="!intelligentShow('area')">
              <li
                v-for="(sItem, index) in intelligent.result['area']"
                :key="sItem.id + sItem.name"
                @click="showDetails_intelligent('area', sItem.id)"
              >
                <h3>{{ index + 1 }}</h3>
                <span class="title" :title="sItem.name">{{ sItem.name }}</span>
                <span class="address" :title="sItem.address">{{
                  sItem.address
                }}</span>
              </li>
            </ul>
          </el-tab-pane>
          <el-tab-pane label="行政区域" name="xzarea">
            <ul class="content" v-show="!intelligentShow('xzarea')">
              <li
                v-for="(sItem, index) in intelligent.result['xzarea']"
                :key="sItem.id + sItem.name"
                @click="showDetails_intelligent('xzarea', sItem.id)"
              >
                <h3>{{ index + 1 }}</h3>
                <span class="title" :title="sItem.name">{{ sItem.name }}</span>
                <span class="address" :title="sItem.address">{{
                  sItem.address
                }}</span>
              </li>
            </ul>
          </el-tab-pane>
          <el-tab-pane label="其他" name="keywords">
            <ul class="content" v-show="!intelligentShow('keywords')">
              <li
                v-for="(sItem, index) in intelligent.result['keywords']"
                :key="sItem.id + sItem.name"
                @click="showDetails_intelligent('keywords', sItem.id)"
              >
                <h3>{{ index + 1 }}</h3>
                <span class="title" :title="sItem.name">{{ sItem.name }}</span>
                <span class="address" :title="sItem.address">{{
                  sItem.address
                }}</span>
              </li>
            </ul>
          </el-tab-pane>
        </el-tabs>
      </e6-box> -->
      <!-- 标注类型选择层 -->
      <div class="cBox" v-show="markTypeLayerShow">
        <i class="e6-icon-delete_line" @click="closeMarkTypeLayer"></i>
        <ul>
          <li @click="markOverlay('rectangle')">
            <img :src="iconsObj.rect" />
            <span>矩形</span>
          </li>
          <li @click="markOverlay('polygon')">
            <img :src="iconsObj.polygon" />
            <span>多边形</span>
          </li>
        </ul>
      </div>
      <!-- 添加marker详情层 -->
      <e6-box
        class="editLayer"
        ref="markerLayer"
        :title="operType == 1 ? '修改圆形区域' : '添加圆形区域'"
        @closeFun="mCloseLayer"
      >
        <div class="tContent">
          <el-form
            :model="mParams"
            :rules="rules"
            size="mini"
            ref="form_marker"
            label-width="80px"
            class="formLayer"
          >
            <el-form-item label="名称" prop="name">
              <div class="horizontal">
                <el-input
                  size="mini"
                  class="colorCol"
                  v-model="mParams.name"
                  :maxlength="markerAndAreaInputFieldLimit.areaName"
                ></el-input>
                <el-color-picker
                  v-model="mParams.titleColor"
                  size="mini"
                  class="colorPicker"
                  :predefine="predefineColors"
                ></el-color-picker>
              </div>
            </el-form-item>
            <el-form-item label="面积" prop="areaAcreage">
              <div class="horizontal">
                <el-input
                  size="mini"
                  v-model="mParams.areaAcreage"
                  class="colorCol"
                  disabled
                >
                  <template slot="append">k㎡</template>
                </el-input>
                <el-color-picker
                  v-model="mParams.acreageColor"
                  size="mini"
                  class="colorPicker"
                  @change="mChangeColor"
                  :predefine="predefineColors"
                ></el-color-picker>
              </div>
            </el-form-item>
            <el-form-item label="自编号" prop="code">
              <el-input
                size="mini"
                v-model="mParams.code"
                :maxlength="markerAndAreaInputFieldLimit.areaCode"
              ></el-input>
            </el-form-item>
            <el-form-item label="类型" prop="categoryId">
              <dict-select
                v-model="mParams.categoryId"
                :pkey="'area_category'"
              ></dict-select>
            </el-form-item>
            <el-form-item label="共享模式" prop="share">
              <el-select
                v-model="mParams.share"
                placeholder="请选择"
                size="mini"
                filterable
              >
                <el-option
                  v-for="item in shareList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="所属部门" prop="orgId">
              <e6-select
                :dataList="organizations"
                v-on:multipleSelect="mSelectOrg"
                :filterable="true"
                :slotTemplate="'tree'"
                :placeholder="'请选择'"
                widthData="165px"
                ref="orgSelect_marker"
              ></e6-select>
            </el-form-item>
            <el-form-item label="半径" prop="rangeId">
              <!-- <el-select
                v-model="mParams.rangeId"
                placeholder="请选择"
                size="mini"
                class="radius-select"
                @change="mChangeRadius"
              >
                <el-option
                  v-for="item in mRadiusList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select> -->
              <el-input
                class="radius-select"
                v-model="mParams.rangeId"
                placeholder="请选择"
                @blur="mChangeRadius"
              ></el-input>
              <span class="radius-label">米</span> </el-form-item
            ><br />
            <el-form-item label="经度" prop="lng84">
              <el-input
                size="mini"
                v-model.number="mParams.lng84"
                @input.native="mLngLatChange"
              ></el-input>
            </el-form-item>
            <el-form-item label="纬度" prop="lat84">
              <el-input
                size="mini"
                v-model.number="mParams.lat84"
                @input.native="mLngLatChange"
              ></el-input>
            </el-form-item>
            <el-form-item label="位置" prop="address" class="wholeRow">
              <el-input
                size="mini"
                v-model="mParams.address"
                :maxlength="markerAndAreaInputFieldLimit.position"
              ></el-input>
            </el-form-item>
            <el-form-item label="备注" prop="remark" class="wholeRow">
              <el-input
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 4 }"
                v-model="mParams.remark"
                :maxlength="markerAndAreaInputFieldLimit.remark"
                show-word-limit
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div class="btnBox">
          <el-button size="mini" class="btn" @click="mCloseLayer"
            >取消</el-button
          >
          <el-button
            type="primary"
            size="mini"
            class="btn"
            plain
            @click="mRedrawClick"
            >重绘</el-button
          >
          <el-button type="primary" size="mini" class="btn" @click="mSaveClick"
            >确定</el-button
          >
        </div>
      </e6-box>
      <!-- 添加area详情层 -->
      <e6-box
        class="editLayer"
        ref="areaLayer"
        :title="operType == 1 ? '修改区域' : '添加区域'"
        @closeFun="aCloseLayer"
      >
        <div class="tContent">
          <el-form
            :model="aParams"
            :rules="rules"
            ref="form_area"
            size="mini"
            label-width="85px"
            class="formLayer"
          >
            <el-form-item label="名称" prop="name">
              <div class="horizontal">
                <el-input
                  size="mini"
                  class="colorCol"
                  v-model="aParams.name"
                  :maxlength="markerAndAreaInputFieldLimit.areaName"
                ></el-input>
                <el-color-picker
                  v-model="aParams.titleColor"
                  size="mini"
                  class="colorPicker"
                  :predefine="predefineColors"
                ></el-color-picker>
              </div>
            </el-form-item>
            <el-form-item label="面积" prop="areaAcreage">
              <div class="horizontal">
                <el-input
                  size="mini"
                  v-model="aParams.areaAcreage"
                  class="colorCol"
                  disabled
                >
                  <template slot="append">k㎡</template>
                </el-input>
                <el-color-picker
                  v-model="aParams.acreageColor"
                  size="mini"
                  class="colorPicker"
                  :predefine="predefineColors"
                  @change="aChangeColor"
                ></el-color-picker>
              </div>
            </el-form-item>
            <el-form-item label="自编号" prop="code">
              <el-input
                size="mini"
                v-model="aParams.code"
                :maxlength="markerAndAreaInputFieldLimit.areaCode"
              ></el-input>
            </el-form-item>
            <el-form-item label="类型" prop="categoryId">
              <dict-select
                v-model="aParams.categoryId"
                :pkey="'area_category'"
              ></dict-select>
              <!-- <el-select
                v-model="aParams.categoryId"
                placeholder="请选择"
                size="mini"
                filterable
              >
                <el-option
                  v-for="item in categoryList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select> -->
            </el-form-item>
            <el-form-item label="共享模式" prop="share">
              <el-select
                v-model="aParams.share"
                placeholder="请选择"
                size="mini"
                filterable
                clearable
              >
                <el-option
                  v-for="item in shareList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="所属部门" prop="orgId">
              <e6-select
                :dataList="organizations"
                v-on:multipleSelect="aSelectOrg"
                :filterable="true"
                :slotTemplate="'tree'"
                :placeholder="'请选择'"
                widthData="165px"
                ref="orgSelect_area"
              ></e6-select>
            </el-form-item>
            <el-form-item label="经度" prop="lng84">
              <el-input
                size="mini"
                v-model.number="aParams.lng84"
                @input.native="aLngLatChange"
              ></el-input>
            </el-form-item>
            <el-form-item label="纬度" prop="lat84">
              <el-input
                size="mini"
                v-model.number="aParams.lat84"
                @input.native="aLngLatChange"
              ></el-input>
            </el-form-item>
            <el-form-item label="区域联系人" prop="contact">
              <el-input size="mini" v-model="aParams.contact"></el-input>
            </el-form-item>
            <el-form-item label="区域联系方式" prop="telephone">
              <el-input size="mini" v-model="aParams.telephone"></el-input>
            </el-form-item>
            <el-form-item label="位置" prop="address" class="wholeRow">
              <el-input
                size="mini"
                v-model="aParams.address"
                :maxlength="markerAndAreaInputFieldLimit.position"
              ></el-input>
            </el-form-item>
            <el-form-item label="备注" prop="remark" class="wholeRow">
              <el-input
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 4 }"
                v-model="aParams.remark"
                :maxlength="markerAndAreaInputFieldLimit.remark"
                show-word-limit
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div class="btnBox">
          <el-button size="mini" class="btn" @click="aCloseLayer"
            >取消</el-button
          >
          <el-button
            type="primary"
            size="mini"
            class="btn"
            plain
            @click="aRedrawClick"
            >重绘</el-button
          >
          <el-button type="primary" size="mini" class="btn" @click="aSaveClick"
            >确定</el-button
          >
        </div>
      </e6-box>
      <!-- 添加行政区域详情层 -->
      <e6-box
        class="editLayer"
        ref="areaXzLayer"
        :title="operType == 1 ? '修改行政区域' : '添加行政区域'"
        @closeFun="aXzCloseLayer"
      >
        <div class="tContent">
          <el-form
            :model="aXzParams"
            :rules="rules"
            ref="form_areaXz"
            size="mini"
            label-width="85px"
            class="formLayer"
          >
            <el-form-item label="选择区域" style="width: 100%;" prop="cityName">
              <e6-city
                class="xz-area-city"
                :label="aXzParams.cityName"
                @selected="xzCitySelect"
              ></e6-city>
            </el-form-item>
            <el-form-item label="名称" prop="name">
              <div class="horizontal">
                <el-input
                  size="mini"
                  class="colorCol"
                  v-model="aXzParams.name"
                  :maxlength="markerAndAreaInputFieldLimit.areaName"
                ></el-input>
                <el-color-picker
                  v-model="aXzParams.titleColor"
                  size="mini"
                  class="colorPicker"
                  :predefine="predefineColors"
                ></el-color-picker>
              </div>
            </el-form-item>
            <el-form-item label="面积" prop="areaAcreage">
              <div class="horizontal">
                <el-input
                  size="mini"
                  v-model="aXzParams.areaAcreage"
                  class="colorCol"
                  disabled
                >
                  <template slot="append">k㎡</template>
                </el-input>
                <el-color-picker
                  v-model="aXzParams.acreageColor"
                  size="mini"
                  class="colorPicker"
                  @change="aXzChangeColor"
                  :predefine="predefineColors"
                ></el-color-picker>
              </div>
            </el-form-item>
            <el-form-item label="自编号" prop="code">
              <el-input
                size="mini"
                v-model="aXzParams.code"
                :maxlength="markerAndAreaInputFieldLimit.areaCode"
              ></el-input>
            </el-form-item>
            <el-form-item label="类型" prop="categoryId">
              <dict-select
                v-model="aXzParams.categoryId"
                :pkey="'area_category'"
              ></dict-select>
              <!-- <el-select
                v-model="aXzParams.categoryId"
                placeholder="请选择"
                size="mini"
                filterable
              >
                <el-option
                  v-for="item in categoryList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select> -->
            </el-form-item>
            <el-form-item label="共享模式" prop="share">
              <el-select
                v-model="aXzParams.share"
                placeholder="请选择"
                size="mini"
                filterable
                clearable
              >
                <el-option
                  v-for="item in shareList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="所属部门" prop="orgId">
              <e6-select
                :dataList="organizations"
                v-on:multipleSelect="aXzSelectOrg"
                :filterable="true"
                :slotTemplate="'tree'"
                :placeholder="'请选择'"
                widthData="165px"
                ref="orgSelect_xzarea"
              ></e6-select>
            </el-form-item>
            <el-form-item label="经度" prop="lng84">
              <el-input
                size="mini"
                v-model.number="aXzParams.lng84"
                readonly
              ></el-input>
            </el-form-item>
            <el-form-item label="纬度" prop="lat84">
              <el-input
                size="mini"
                v-model.number="aXzParams.lat84"
                readonly
              ></el-input>
            </el-form-item>
            <el-form-item label="区域联系人" prop="contact">
              <el-input size="mini" v-model="aXzParams.contact"></el-input>
            </el-form-item>
            <el-form-item label="区域联系方式" prop="telephone">
              <el-input size="mini" v-model="aXzParams.telephone"></el-input>
            </el-form-item>
            <el-form-item label="位置" prop="address" class="wholeRow">
              <el-input
                size="mini"
                v-model="aXzParams.address"
                :maxlength="markerAndAreaInputFieldLimit.position"
              ></el-input>
            </el-form-item>
            <el-form-item label="备注" prop="remark" class="wholeRow">
              <el-input
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 4 }"
                v-model="aXzParams.remark"
                :maxlength="markerAndAreaInputFieldLimit.remark"
                show-word-limit
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div class="btnBox">
          <el-button size="mini" class="btn" @click="aXzCloseLayer"
            >取消</el-button
          >
          <!-- <el-button
            type="primary"
            size="mini"
            class="btn"
            plain
            @click="aXzRedrawClick"
            >重绘</el-button
          > -->
          <el-button
            type="primary"
            size="mini"
            class="btn"
            @click="aXzSaveClick"
            >确定</el-button
          >
        </div>
      </e6-box>
    </div>
  </div>
</template>
<script>
//import "e6-module-map-service/assets/AFont/iconfont.css";
//import { lazyAMapApiLoaderInstance } from "vue-amap";
// import { GaodeAPI } from "e6-base-map/utils/gaode/gaodeAPI.js";
// import { GoogleAPI } from "e6-base-map/utils/map/googleAPI.js";
// import { MapbarAPI } from "e6-base-map/utils/mapbar/mapbarAPI.js";
import e6Box from "@/components/e6Box";
import e6Select from "e6select";
import e6City from "e6city";
// import { Scrollbar } from "element-ui";
import {
  getCenterInfo,
  getNewLLByOld,
  ll02To84,
  ll84To02,
  getAcreage,
  dealWeather,
  initMap
} from "e6-base-map/utils/map/mapToolsFun.js";
// import vuescroll from "vuescroll";
// import { mapGetters } from "vuex";
// const debounce = require("lodash/debounce");
import {
  getXzAreaInfoByCity, //新增/修改时根据选择的行政区域绘制
  fetchCityByLonLat, //地图拖拽获取中心省市
  fetchPositionByLonLat //拉框绘制区域后自动获取区域位置
} from "@/api/monitorCenter/logisticsMap";
import _ from "lodash";
export default {
  name: "LogisticsMap",
  components: {
    e6Box,
    e6Select,
    e6City
  },
  props: {
    markerDatas: {
      type: Array,
      default: function() {
        return [];
      }
    },
    areaDatas: {
      type: Array,
      default: function() {
        return [];
      }
    },
    xzAreaDatas: {
      type: Array,
      default: function() {
        return [];
      }
    },
    center: {
      type: Array,
      default: function() {
        return [113.57373, 22.29112];
      }
    },
    // categoryList: {
    //   type: Array,
    //   default: function() {
    //     return [
    //       { id: 1, name: "工厂" },
    //       { id: 2, name: "收费站" },
    //       { id: 3, name: "仓库" },
    //       { id: 4, name: "码头堆场" },
    //       { id: 5, name: "物流园" },
    //       { id: 6, name: "其他" },
    //       { id: 7, name: "跟踪点" },
    //       { id: 8, name: "网点" }
    //     ];
    //   }
    // },
    organizations: {
      type: Array,
      default: function() {
        return [];
      }
    },
    navigationDatas: {
      type: Array,
      default: function() {
        return [];
      }
    },
    isFullScreen: {
      type: Boolean,
      default: false
    },
    shareList: {
      type: Array,
      default: function() {
        return [
          { value: 1, label: "全局" },
          { value: 4, label: "个人" },
          { value: 2, label: "部门" }
        ];
      }
    },
    mRadiusList: {
      type: Array,
      default: function() {
        return [
          { value: 50, label: "50" },
          { value: 100, label: "100" },
          { value: 200, label: "200" },
          { value: 500, label: "500" },
          { value: 1000, label: "1000" },
          { value: 1500, label: "1500" },
          { value: 2000, label: "2000" }
        ];
      }
    },
    mapAuth: {
      type: Object,
      default: function() {
        return {
          物流地图: {
            自定义点及区域管理: {
              exp: false,
              ipm: false,
              add: false,
              query: false,
              pic: false,
              ter: false,
              mod: false,
              del: false
            }
          }
        };
      }
    },
    useMapLayer: {
      type: Number,
      default: 0
    },
    isLabelAlwaysShow: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    // 智能搜索 默认显示的tab名称
    // intelligentShowTabName() {
    //   let name = "vehicle";
    //   if (this.intelligent.result) {
    //     if (
    //       this.intelligent.result["vehicle"] &&
    //       this.intelligent.result["vehicle"].length > 0
    //     ) {
    //       name = "vehicle";
    //     } else if (
    //       this.intelligent.result["marker"] &&
    //       this.intelligent.result["marker"].length > 0
    //     ) {
    //       name = "marker";
    //     } else if (
    //       this.intelligent.result["area"] &&
    //       this.intelligent.result["area"].length > 0
    //     ) {
    //       name = "area";
    //     } else if (
    //       this.intelligent.result["keywords"] &&
    //       this.intelligent.result["keywords"].length > 0
    //     ) {
    //       name = "keywords";
    //     }
    //   }
    //   return name;
    // }
  },
  data() {
    // let fValidateName = (rule, value, callback) => {
    //   this.validateFenceName({
    //     rule,
    //     value,
    //     callback,
    //     params: this.fenceType == 1 ? this.mParams : this.aParams
    //   });
    // };
    // let lValidateName = (rule, value, callback) => {
    //   this.validateLineName({
    //     rule,
    //     value,
    //     callback,
    //     params: this.lParams
    //   });
    // };
    let orgId_validator = (rule, value, callback) => {
      if (value == 0) {
        callback(new Error("所属部门不能为空"));
      } else {
        callback();
      }
    };
    let telephoneValid = (rule, value, callback) => {
      let telReg = /^((13[0-9])|(14[5|7])|(15([0-3]|[5-9]))|(18[0,5-9])|(166)|(199)|(17([1-3]|[5-8])))\d{8}$|^0\d{2,3}-?\d{7,8}$/;
      if (value === "" || telReg.test(value)) {
        callback();
      } else {
        callback("请输入正确的电话格式");
      }
    };
    let radiusValid = (rule, value, callback) => {
      let telReg = /^[1-9]\d*$/;
      if (value > 1000 || value < 1 || !telReg.test(value)) {
        callback("请输入1~1000之间的整数");
      } else {
        callback();
      }
    };
    return {
      mapContainer_wh: {
        width: 0,
        height: 0
      },
      btnLoading: false,
      preMoveCenter: null, // 移动地图的旧的中心点
      isMapLoading: false,
      mapAuthData: {
        物流地图: {
          自定义点及区域管理: {
            exp: false,
            ipm: false,
            add: false,
            query: false,
            pic: false,
            ter: false,
            mod: false,
            del: false
          }
        }
      },
      iconsObj: {
        start: require("e6-base-map/assets/e6Images/navigation/start.png"),
        end: require("e6-base-map/assets/e6Images/navigation/end.png"),
        arrow: require("e6-base-map/assets/e6Images/arrow.png"),
        marker: require("e6-base-map/assets/e6Images/map/marker.png"),
        rect: require("e6-base-map/assets/e6Images/map/rect.png"),
        polygon: require("e6-base-map/assets/e6Images/map/polygon.png")
      },
      isMapChangeBox: false,
      isMapToolBarShow: false, // 地图工具条显示与否
      isToolBoxShow: false, // 地图工具箱 弹出层是否显示
      map: null,
      mapAPI: null,
      mapType: "baidu",
      mapGeoType: "tileLayer", // tileLayer-- 平面  satellite--卫星
      // mapType_default: "gaode",
      map_city: "", // 城市
      logisAreas_centerMarker: [], //物流area的中心点marker
      xzAreas_centerMarker: [], //行政area的中心点marker
      logisAreas: [], //物流area
      xzAreas: [], //行政area
      logisCameras: [], //物流camera
      tempOverlay_marker: [], //区域中心点
      tempOverlay_circle: [],
      tempOverlay: [],
      marker: null,
      circle: null,
      area: null,
      areaXz: null,
      strokeWeight: 5,
      geocoder: null, //geo对象（地址解析和逆地址解析）
      logisShow: false,
      markMarkerShow: false,
      markTypeLayerShow: false,
      operType: 0, // 0 - 添加；1 - 修改
      fenceType: 0, // 电子围栏类型，用于重绘共享相关不变数据。1 - 点；2 - 区域；
      // 快捷颜色选择
      predefineColors: [
        "#56bb24",
        "#f34747",
        "#8642da",
        "#46bfea",
        "#849bbd",
        "#e39726",
        "#1889fd",
        "#73767a"
      ],
      // marker相关
      // markerLayerShow: false,
      mLevelPopShow: false,
      mIconPopShow: false,
      mShown: false, //marker是否已经绘制在地图上（因为marker有级别显示，所以mEyeShow不足以表示marker目前是否都已经绘制到了地图上。）
      mParams: {
        id: 0,
        name: "",
        titleColor: "#48494c",
        nameColor: "#000",
        areaAcreage: 0,
        acreageColor: "#409eff",
        categoryId: "",
        code: "",
        orgId: 0,
        share: 1,
        rangeId: 200,
        lng84: 0,
        lat84: 0,
        lng02: 0,
        lat02: 0,
        address: "",
        remark: "",
        contact: "",
        telephone: "",
        llObjArr: [],
        typeId: 3
      },
      // area相关
      // areaLayerShow: false,
      aLevelPopShow: false,
      aShown: false, //area是否已经绘制在地图上
      aParams: {
        id: 0,
        name: "",
        titleColor: "#48494c",
        areaAcreage: 0,
        acreageColor: "#409eff",
        categoryId: "",
        code: "",
        orgId: 0,
        share: 1,
        lng84: null,
        lat84: null,
        lng02: null,
        lat02: null,
        address: "",
        contact: "",
        telephone: "",
        remark: "",
        llObjArr: [],
        typeId: 1 //图形类型  1 - 矩形, 2 - 多边形
      },
      aXzShown: false, // 是否已经绘制在地图上
      aXzParams: {
        id: 0,
        name: "",
        cityName: "",
        titleColor: "#000",
        areaAcreage: 0,
        acreageColor: "#409eff",
        categoryId: "",
        code: "",
        orgId: 0,
        share: 1,
        lng84: null,
        lat84: null,
        lng02: null,
        lat02: null,
        address: "",
        contact: "",
        telephone: "",
        remark: "",
        llObjArr: [],
        typeId: 4
      },
      // 输入框长度限制 marker & area
      markerAndAreaInputFieldLimit: {
        areaName: 50, // 区域名称
        areaCode: 50, // 区域编号
        position: 256, // 地理位置信息
        remark: 256 // 备注
      },
      // 校验
      rules: {
        // name: [{ required: true, validator: fValidateName, trigger: "blur" }],
        cityName: [
          { required: true, message: "请选择行政区域", trigger: "blur" }
        ],
        name: [{ required: true, message: "名称不能为空", trigger: "blur" }],
        share: [{ required: true, message: "请选择共享模式", trigger: "blur" }],
        lng84: [
          { required: true, message: "经度不能为空", trigger: "blur" },
          { type: "number", message: "经度必须为数字值", trigger: "blur" }
        ],
        lat84: [
          { required: true, message: "纬度不能为空", trigger: "blur" },
          { type: "number", message: "纬度必须为数字值", trigger: "blur" }
        ],
        orgId: [
          { required: true, validator: orgId_validator, trigger: "blur" }
        ],
        rangeId: [
          { required: true, message: "半径不能为空", trigger: "blur" },
          { validator: radiusValid, trigger: "blur" }
        ],
        contact: [{ max: 32, message: "不可超过32个字符", trigger: "blur" }],
        telephone: [{ validator: telephoneValid, trigger: "blur" }]
      },
      // 智能搜索
      intelligent: {
        searchTxt: "",
        marker: null,
        moreMarkers: [], //点开更多的全部小图标的markers
        moreList: [],
        // moreType: "",
        result: {}
      }
    };
  },
  watch: {
    // categoryList: {
    //   handler: function() {
    //     if (this.aParams.categoryId == 0 && this.categoryList.length > 0) {
    //       this.aParams.categoryId = this.categoryList[0].id;
    //     }
    //     if (this.aXzParams.categoryId == 0 && this.categoryList.length > 0) {
    //       this.aXzParams.categoryId = this.categoryList[0].id;
    //     }
    //   },
    //   immediate: true
    // },
    mapAuth: {
      handler: function() {
        this.mapAuthData = Object.assign({}, this.mapAuth);
      },
      deep: true,
      immediate: true
    },
    centerLonLat: {
      handler: function() {
        this.setDefaultCenter();
      },
      immediate: true
    }
  },
  methods: {
    randomString() {
      return this.$parent.randomString(20);
    },
    setDefaultCenter() {
      if (!this.mapAPI) return;
      let lnglat = this.mapAPI.createLngLat({
        lng84: this.centerLonLat.split(",")[1],
        lat84: this.centerLonLat.split(",")[0]
      });
      this.mapAPI.setZoomAndCenter(10, lnglat);
    },
    resize() {
      this.$nextTick(() => {
        let mapContainer = this.$refs.mapContainer;
        this.mapContainer_wh.width = mapContainer.clientWidth;
        this.mapContainer_wh.height = mapContainer.clientHeight;
        this.mapAPI &&
          this.mapAPI.resize({
            width: mapContainer.clientWidth,
            height: mapContainer.clientHeight
          });
      });
    },
    // 创建marker
    createMarkers(mDatasArr) {
      let markers = [];
      if (mDatasArr.length > 0) {
        mDatasArr.forEach(element => {
          if (element) {
            let opts = Object.assign(
              {
                width: 28,
                height: 28,
                icon: require("e6-base-map/assets/e6Images/logistic/area_icon_15_b.png"),
                label: "",
                extData: {}
              },
              element
            );
            let extObj = Object.assign(
              {
                id: -1,
                setView: false,
                type: "marker",
                mapAuthData: this.mapAuthData,
                clickback: null
              },
              element.extData
            );
            opts.extData = extObj;
            let lnglat = this.mapAPI.createLngLat(opts.llObj);
            if (!lnglat) {
              return;
            }
            let marker = this.mapAPI.createMarker({
              position: lnglat,
              ...opts
            });
            if (marker) {
              // marker.id = opts.extData.id || -1;
              markers.push(marker);
              if (opts.extData.clickback) {
                this.mapAPI.addListener_click(marker, opts.extData.clickback);
              }
            }
          }
        });
      }
      return markers;
    },
    // 创建area
    createAreas(aDatasArr) {
      let areas = [];
      if (aDatasArr.length > 0) {
        aDatasArr.forEach(element => {
          let opts = Object.assign(
            {
              extData: {
                id: -1,
                type: element.extData.type,
                mapAuthData: this.mapAuthData,
                setView: false
              }
            },
            element
          );
          let path = [];
          opts.llObjArr.forEach(llObj => {
            path.push(this.mapAPI.createLngLat(llObj));
          });
          let area = this.mapAPI.createPolygon({
            path,
            ...opts
          });
          if (area) {
            // area.id = opts.extData.id || -1;
            areas.push(area);
          }
        });
      }
      return areas;
    },
    createAreas_center(aDatasArr) {
      let texts = [];
      if (aDatasArr.length > 0) {
        aDatasArr.forEach(element => {
          let opts = Object.assign(
            {
              extData: {
                id: -1,
                type: "area",
                mapAuthData: this.mapAuthData,
                clickback: null
              }
            },
            element
          );
          let lnglat = this.mapAPI.createLngLat(opts.llObj);
          let text = this.mapAPI.createText({
            position: lnglat,
            ...opts
          });
          // text.id = opts.extData.id || -1;
          texts.push(text);
          if (opts.extData.clickback != null) {
            this.mapAPI.addListener_click(text, opts.extData.clickback);
          }
        });
      }
      return texts;
    },
    // 创建line
    createLines(lDatasArr) {
      let lines = [];
      if (lDatasArr.length > 0) {
        lDatasArr.forEach(element => {
          let opts = Object.assign(
            {
              extData: {
                id: -1,
                type: "line",
                mapAuthData: this.mapAuthData,
                setView: false
              }
            },
            element
          );
          let path = [];
          opts.llObjArr.forEach(llObj => {
            path.push(this.mapAPI.createLngLat(llObj));
          });
          let line = this.mapAPI.createLine({
            path,
            ...opts
          });
          // line.id = opts.extData.id || -1;
          lines.push(line);
        });
      }
      return lines;
    },
    // 标注overlay
    markOverlay(type) {
      this.clearTempAreas();
      this.closeEditBoxs();
      this.closeAllOverLayers();
      this.logisShow = false;
      this.markTypeLayerShow = false;
      let rOpts = {};
      switch (type) {
        case "marker":
          rOpts = {
            type: "marker",
            callback: this.markback_marker,
            opts: {
              draggable: true,
              height: 24,
              width: 24
            }
          };
          break;
        case "rectangle":
          rOpts = {
            type: "rectangle",
            callback: this.markback_rect
          };
          break;
        case "polygon":
          rOpts = {
            type: "polygon",
            callback: this.markback_polygon
          };
          break;
        case "areaXz":
          this.showAreaXzLayer();
          break;
      }
      type != "areaXz" && this.mapAPI.drawOverlay(rOpts);
    },
    // 打开标注类型选择层
    openMarkTypeLayer(hasMarker = false) {
      this.clearTempAreas();
      this.closeEditBoxs();
      this.markMarkerShow = hasMarker;
      this.markTypeLayerShow = true;
      this.logisShow = false;
    },
    // 关闭标注类型选择层
    closeMarkTypeLayer() {
      this.markTypeLayerShow = false;
    },
    // 根据id删除marker或者area
    deleteLogisOverlays(idsArr) {
      this.deleteLogisMarkers(idsArr);
      this.deleteLogisAreas(idsArr);
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    //----------------------------------marker------------------------------//
    // 删除多个物流marker
    deleteLogisMarkers(mIdsArr = []) {
      for (let i = this.logisMarkers.length - 1; i >= 0; i--) {
        let marker = this.logisMarkers[i];
        if (mIdsArr.length == 0 || mIdsArr.indexOf(marker.id) > -1) {
          this.mapAPI.removeOverlay(marker);
          this.logisMarkers.splice(i, 1);
        }
      }
    },
    // 增加多个物流marker
    addLogisMarkers(mDatasArr) {
      let markers = this.createMarkers(mDatasArr);
      this.mShowOrHideByEye(markers);
      this.logisMarkers = this.logisMarkers.concat(markers);
    },
    //根据“全国省市区”情况加载点
    mShowOrHideByLevel() {
      let currentZoom = this.mapAPI.getZoom();
      let displayZoom = this.mapAPI.getZoomByLevelTxt(this.mLevel);
      if (this.mEyeShow) {
        if (currentZoom >= displayZoom && !this.mShown) {
          this.mapAPI.addOverlay(this.logisMarkers);
          this.mShown = true;
        } else if (currentZoom < displayZoom && this.mShown) {
          this.mapAPI.removeOverlay(this.logisMarkers);
          this.mShown = false;
          this.mapAPI.closeInfoWindow();
        }
      }
    },
    //根据“eye”情况加载点
    mShowOrHideByEye(markersArr) {
      let markers = this.logisMarkers;
      if (typeof markersArr != "undefined" && markersArr != null) {
        markers = markersArr;
      }
      if (this.mEyeShow) {
        let currentZoom = this.mapAPI.getZoom();
        let displayZoom = this.mapAPI.getZoomByLevelTxt(this.mLevel);
        if (currentZoom >= displayZoom) {
          this.mapAPI.addOverlay(markers);
          this.mShown = true;
        }
      } else {
        if (this.mShown) {
          this.mapAPI.removeOverlay(markers);
          this.mShown = false;
          this.mapAPI.closeInfoWindow();
        }
      }
    },
    //标注marker回调
    markback_marker(overlay) {
      this.marker = overlay;
      this.mParams.typeId = 3;
      //处理lnglat和address
      let oLngLat = this.mapAPI.getPosition(overlay);
      this.mGetAddress(oLngLat.lnglat);
      this.mParams.lng02 = oLngLat.lng;
      this.mParams.lat02 = oLngLat.lat;
      this.mLnglatConvert(true);
      this.operType = 0;
      this.mAddDragListener();
      //绘制circle
      this.mDrawCircle(oLngLat.lnglat);
      // 计算面积
      this.mParams.areaAcreage = (
        (Math.PI * Math.pow(this.mParams.rangeId, 2)) /
        Math.pow(1000, 2)
      ).toFixed(3);
      //重绘时同步原有信息
      if (this.fenceType != 0 && this.fenceType != 1) {
        let params = {};
        if (this.fenceType == 2) {
          params = this.aParams;
        }
        this.mParams.id = params.id;
        this.mParams.name = params.name;
        this.mParams.nameColor = params.nameColor;
        this.mParams.acreageColor = params.acreageColor;
        this.mParams.categoryId = params.categoryId;
        this.mParams.code = params.code;
        this.mParams.orgId = params.orgId;
        this.mParams.share = params.share;
        this.mParams.address = params.address;
        this.mParams.remark = params.remark;
      }
      this.fenceType = 1;
      this.$refs.markerLayer.showBox();
    },
    // 监听marker的drag的事件
    mAddDragListener() {
      this.mapAPI.addListener_drag(this.marker, rObj => {
        this.mParams.lng02 = rObj.lng;
        this.mParams.lat02 = rObj.lat;
        this.mLnglatConvert(true);
        this.mGetAddress(this.mapAPI.getPosition(this.marker).lnglat);
        if (this.circle != null) {
          this.mapAPI.setPosition(
            this.circle,
            this.mapAPI.getPosition(this.marker).lnglat
          );
        }
      });
    },
    mLnglatConvert(is02To84) {
      if (is02To84) {
        let llObj_84 = ll02To84(this.mParams.lng02, this.mParams.lat02);
        this.mParams.lng84 = +llObj_84.lng.toFixed(6);
        this.mParams.lat84 = +llObj_84.lat.toFixed(6);
      } else {
        let llObj_02 = ll02To84(this.mParams.lng84, this.mParams.lat84);
        this.mParams.lng02 = +llObj_02.lng.toFixed(6);
        this.mParams.lat02 = +llObj_02.lat.toFixed(6);
      }
    },
    // 绘制circle
    mDrawCircle(lnglat) {
      this.circle = this.mapAPI.createCircle({
        center: lnglat,
        radius: this.mParams.rangeId,
        strokeColor: this.mParams.acreageColor,
        fillColor: this.mParams.acreageColor
      });
      this.mapAPI.addOverlay(this.circle);
    },
    //获取marker的地址
    mGetAddress(lnglat) {
      this.mapAPI.getAddress(lnglat, result => {
        if (result != null) {
          this.mParams.address = result.formattedAddress;
        }
      });
    },
    // marker省市区修改事件
    mLevelChange(level) {
      this.mLevelPopShow = false;
      this.$emit("update:mLevel", level);
      this.$emit("levelChange", "marker", level);
    },
    // marker的eye控制显隐
    mEyeClick() {
      let IsShow = !this.mEyeShow;
      this.$emit("update:mEyeShow", IsShow);
      this.$emit("eyeChange", "marker", IsShow);
    },
    //修改marker触发事件
    mOpenLayer(opts) {
      this.mapAPI.removeOverlay([this.marker, this.circle]);
      this.closeAllOverLayers();
      Object.assign(this.mParams, opts);
      if (this.mParams.categoryId == 0) {
        this.mParams.categoryId = "";
      }
      if (this.mParams.id != 0) {
        this.operType = 1;
      }
      this.fenceType = 1;
      this.$refs.orgSelect_marker.setSelectList([this.mParams.orgId]);
      this.$refs.markerLayer.showBox(); //打开marker面板
      //marker
      let lnglat = this.mapAPI.createLngLat({
        lng84: this.mParams.lng84,
        lat84: this.mParams.lat84,
        lng02: this.mParams.lng02,
        lat02: this.mParams.lat02
      });
      this.marker = this.mapAPI.createMarker({
        position: lnglat,
        color: this.mParams.nameColor,
        draggable: true
      });
      this.mapAPI.addOverlay(this.marker);
      this.mAddDragListener();
      this.mDrawCircle(lnglat);
      this.mapAPI.setCenter(lnglat);
      this.mapAPI.setzIndex({ marker: this.marker, zIndex: 500 });
      // // 计算面积
      // this.mParams.areaAcreage = (
      //   (Math.PI * Math.pow(this.mParams.radius, 2)) /
      //   Math.pow(1000, 2)
      // ).toFixed(3);
      //将line放在可视范围之内
      this.mapAPI.setFitView({ overlayList: [this.marker] });
    },
    //marker面板保存
    // operType: 0 - 添加；1 - 修改
    mSaveClick() {
      this.$refs.form_marker.validate(valid => {
        if (valid) {
          this.$emit("saveOverlay", {
            type: "marker",
            operType: this.operType,
            params: this.mParams
          });
        } else {
          return false;
        }
      });
    },
    // 关闭marker面板
    mCloseLayer() {
      this.$refs.markerLayer.closeBox(); // 组件中已经处理，主动调此方法不会再触发回调，防止死循环。
      this.$refs.orgSelect_marker.multipleRemoveAll();
      this.operType = 0;
      this.fenceType = 0;
      this.mapAPI.removeOverlay([this.marker, this.circle]);
      this.marker = null;
      this.circle = null;
      this.mParams = {
        id: 0,
        name: "",
        titleColor: "#48494c",
        nameColor: "#000",
        areaAcreage: 0,
        acreageColor: "#409eff",
        categoryId: "",
        code: "",
        orgId: 0,
        share: 1,
        rangeId: 200,
        lng84: 0,
        lat84: 0,
        lng02: 0,
        lat02: 0,
        address: "",
        remark: "",
        contact: "",
        telephone: "",
        llObjArr: [],
        typeId: 3
      };

      this.resetForm("form_marker");
    },
    //重绘
    mRedrawClick() {
      this.$refs.markerLayer.closeBox(); //打开marker面板
      this.mapAPI.removeOverlay([this.marker, this.circle, this.area]);
      this.marker = null;
      this.circle = null;
      this.area = null;
      this.openMarkTypeLayer(true);
    },
    // marker切换图标
    mChangeIcon() {
      this.mParams.icon = event.srcElement.dataset.src;
      if (this.marker != null) {
        this.mapAPI.setIcon(this.marker, { icon: this.mParams.icon });
      }
    },
    // marker切换半径
    mChangeRadius() {
      if (this.marker != null) {
        this.mParams.areaAcreage = (
          (Math.PI * Math.pow(this.mParams.rangeId, 2)) /
          Math.pow(1000, 2)
        ).toFixed(3);
        this.mapAPI.setOptions(this.circle, {
          radius: this.mParams.rangeId
        });
      }
    },
    // marker切换面积颜色
    mChangeColor() {
      if (this.marker != null) {
        this.mapAPI.setOptions(this.circle, {
          strokeColor: this.mParams.acreageColor,
          fillColor: this.mParams.acreageColor
        });
      }
    },
    mSelectOrg(selArr) {
      if (selArr.length == 0) {
        this.mParams.orgId = 0;
      } else {
        this.mParams.orgId = selArr[0].id;
      }
    },
    // 拉框选择区域之后 获取地理位置
    getAddress(llobj) {
      return new Promise(async resolve => {
        let res = await fetchPositionByLonLat({
          lon: llobj.lng,
          lat: llobj.lat
        });
        // let res = {
        //   code: 1,
        //   message: "OK",
        //   result: {
        //     passDBQuery: true,
        //     placeName:
        //       "广东省东莞市东莞市东城街道桑园村,东莞市东城朝晖学校东北554米,桑圃中路东71米(普通路)"
        //   }
        // };
        if (res.code == 1 && res.result) {
          resolve(res.result.placeName || "");
        } else {
          resolve("");
        }
      });
    },

    //------------------------------------area--------------------------------//
    deleteLogisAreas(aIdsArr = []) {
      for (let i = this.logisAreas.length - 1; i >= 0; i--) {
        let area = this.logisAreas[i];
        let extData = this.mapAPI.getExtData(area);
        if (extData == null) return;
        if (aIdsArr.length == 0 || aIdsArr.includes(extData.id)) {
          this.mapAPI.removeOverlay(area);
          this.logisAreas.splice(i, 1);
        }
      }
      // 删除中心点
      for (let i = this.logisAreas_centerMarker.length - 1; i >= 0; i--) {
        let centerMarker = this.logisAreas_centerMarker[i];
        let extData = this.mapAPI.getExtData(centerMarker);
        if (extData == null) return;
        if (aIdsArr.length == 0 || aIdsArr.includes(extData.id)) {
          this.mapAPI.removeOverlay(centerMarker);
          this.logisAreas_centerMarker.splice(i, 1);
        }
      }
    },
    addLogisAreas(aDatasArr) {
      let areasNotInLayer = [];
      // 处理图吧叠加层逻辑
      if (this.mapType == "mapbar") {
        areasNotInLayer = aDatasArr.filter(m => {
          return this.useMapLayer == 0 || m.inLayer == 0 || m.inLayer == 2;
        });
      } else {
        areasNotInLayer = aDatasArr;
      }
      let areas = this.createAreas(areasNotInLayer);
      this.logisAreas = this.logisAreas.concat(areas);
      //创建area的中心点
      let centerDatasArr = [];
      areasNotInLayer.forEach(aData => {
        let opts = {
          llObj: {
            lng84: aData.lng84 || 0,
            lat84: aData.lat84 || 0,
            lng02: aData.lng02 || 0,
            lat02: aData.lat02 || 0
          },
          icon: require("e6-base-map/assets/e6Images/logistic/blank.png"),
          width: 2,
          height: 2,
          extData: {
            mapAuthData: this.mapAuthData,
            type: "marker",
            id: aData.areaId
          },
          ...aData
        };
        centerDatasArr.push(opts);
      });
      let centerMarkers = this.createAreas_center(centerDatasArr);
      this.logisAreas_centerMarker = this.logisAreas_centerMarker.concat(
        centerMarkers
      );
      this.aShowOrHideByEye({
        areas,
        centerMarkers
      });
    },
    aShowOrHideByLevel() {
      if (this.mapAPI) {
        let currentZoom = this.mapAPI.getZoom();
        let displayZoom = this.mapAPI.getZoomByLevelTxt(this.aLevel);
        if (this.aEyeShow) {
          if (currentZoom >= displayZoom && !this.aShown) {
            this.mapAPI.addOverlay([
              ...this.logisAreas,
              ...this.logisAreas_centerMarker
            ]);
            this.aShown = true;
            this.mapType == "mapbar" &&
              (this.useMapLayer & 1) == 1 &&
              this.aLayerLoader();
          } else if (currentZoom < displayZoom && this.aShown) {
            this.mapAPI.removeOverlay([
              ...this.logisAreas,
              ...this.logisAreas_centerMarker
            ]);
            this.aShown = false;
            this.mapAPI.closeInfoWindow();
            this.mapType == "mapbar" && this.aLayerRemove();
          }
        }
      }
    },
    aShowOrHideByEye(opts) {
      let areas = this.logisAreas;
      let centerMarkers = this.logisAreas_centerMarker;
      if (typeof opts != "undefined") {
        if (typeof opts.areasArr != "undefined" && opts.areasArr != null) {
          areas = opts.areasArr;
        }
        if (
          typeof opts.centerMarkers != "undefined" &&
          opts.centerMarkers != null
        ) {
          centerMarkers = opts.centerMarkers;
        }
      }
      if (this.aEyeShow) {
        if (!this.mapAPI) return;
        let currentZoom = this.mapAPI.getZoom();
        let displayZoom = this.mapAPI.getZoomByLevelTxt(this.aLevel);
        if (currentZoom >= displayZoom) {
          this.mapAPI.addOverlay(areas);
          this.mapAPI.addOverlay(centerMarkers);
          centerMarkers.forEach(marker => this.mapAPI.setTop(marker, false));
          this.aShown = true;
          this.mapType == "mapbar" &&
            (this.useMapLayer & 1) == 1 &&
            this.aLayerLoader();
        }
        // this.aShowOrHideByLevel();
      } else {
        if (this.aShown) {
          this.mapAPI.removeOverlay(areas);
          this.mapAPI.removeOverlay(centerMarkers);
          this.aShown = false;
          this.mapAPI.closeInfoWindow();
          this.mapType == "mapbar" &&
            (this.useMapLayer & 1) == 1 &&
            this.aLayerRemove();
        }
      }
    },
    // 加载图吧叠加层  区域
    aLayerLoader() {
      if (this.areaLayer_mapbar == null) {
        let mOptions = {
          serverPath: this.layers.areaUrl,
          dataPattern: "layerjs[xyname]",
          needData: false,
          tipMode: "always"
        };
        this.areaLayer_mapbar = this.mapAPI.createLayer(mOptions);
        this.areaLayer_mapbar && this.mapAPI.addLayer(this.areaLayer_mapbar);
      }
    },
    //  移除 图吧叠加层  区域
    aLayerRemove() {
      this.areaLayer_mapbar && this.mapAPI.removeLayer(this.areaLayer_mapbar);
      this.areaLayer_mapbar = null;
    },
    markback_rect(overlay) {
      this.aParams.typeId = 1;
      this.markback_area(overlay);
    },
    markback_polygon(overlay) {
      this.aParams.typeId = 2;
      this.markback_area(overlay);
    },
    markback_area(overlay) {
      this.area = overlay;
      let path = this.mapAPI.getPath(overlay);
      let llObjArr_02 = [];
      let llObjArr = []; //存储到aParams中，保存使用
      let llArr_02 = []; //经纬度数组，计算面积使用
      path.forEach(lnglat => {
        let lng02 = this.mapAPI.getLng(lnglat);
        let lat02 = this.mapAPI.getLat(lnglat);
        llObjArr_02.push({ lng: lng02, lat: lat02 });
        llArr_02.push([lng02, lat02]);
        let llObj_84 = ll02To84(lng02, lat02);
        llObjArr.push({
          lng02,
          lat02,
          lng84: llObj_84.lng,
          lat84: llObj_84.lat
        });
      });
      this.aParams.llObjArr = llObjArr.concat();
      let centerInfo = getCenterInfo(llObjArr_02);
      let lnglat = this.mapAPI.createLngLat({
        lng02: centerInfo.lng_center,
        lat02: centerInfo.lat_center
      });
      this.marker = this.mapAPI.createMarker({
        position: lnglat,
        icon: require("e6-base-map/assets/e6Images/logistic/center.png"),
        width: 20,
        height: 20,
        draggable: true
      });
      this.mapAPI.addOverlay(this.marker);
      this.mapAPI.setTop(this.marker, true);
      this.fnGetAddress({
        lng02: centerInfo.lng_center,
        lat02: centerInfo.lat_center
      }).then(add => {
        this.aParams.address = add;
      });
      this.aParams.lng02 = centerInfo.lng_center;
      this.aParams.lat02 = centerInfo.lat_center;
      this.aLnglatConvert(true);
      if (!this.aParams.id) {
        this.operType = 0;
      }
      this.aAddDragListener();
      // 计算面积
      this.aParams.areaAcreage = getAcreage(llArr_02);
      //重绘时同步原有信息
      if (this.fenceType != 0 && this.fenceType != 2) {
        let params = {};
        if (this.fenceType == 1) {
          params = this.mParams;
        }
        this.aParams.id = params.id;
        this.aParams.name = params.name;
        params.titleColor != "" &&
          (this.aParams.titleColor = params.titleColor);
        params.acreageColor != "" &&
          (this.aParams.acreageColor = params.acreageColor);
        this.aParams.categoryId = params.categoryId;
        this.aParams.code = params.code;
        this.aParams.orgId = params.orgId;
        this.aParams.share = params.share;
        this.aParams.address = params.address;
        this.aParams.remark = params.remark;
      }
      if (!this.aParams.id) {
        this.fenceType = 2;
      }

      // this.areaLayerShow = true;
      this.$refs.orgSelect_area.setSelectList([this.organizations[0].id]);
      this.$refs.areaLayer.showBox();
    },
    showTempMarkerById(areaId) {
      // 需要显示的数据
      const areaData = this.markerDatas.find(v => v.areaId === areaId);
      if (!areaData) {
        return false;
      }
      this.clearTempOverlay();
      if (this.aShown) {
        // area 显示着
        let area = this.logisAreas.find(item => {
          return areaId == item.id;
        });
        if (area) {
          // 设置中心
          this.mapAPI.setCenter(
            this.mapAPI.createLngLat({
              lng84: areaData.lonCenter,
              lat84: areaData.latCenter
            })
          );
          this.mapAPI.openInfoWindow(area);
        } else {
          this.addTempArea(areaData);
        }
      } else {
        // area 隐藏
        this.addTempMarker(areaData);
      }
      return true;
    },
    addTempMarker(areaData) {
      let lnglat = this.mapAPI.createLngLat({
        lng84: areaData.lonCenter,
        lat84: areaData.latCenter
      });
      let marker = this.mapAPI.createMarker({
        position: lnglat
      });
      if (marker) {
        this.tempOverlay = marker;
        this.tempOverlay_marker = [marker];
        this.mapAPI.addOverlay(this.tempOverlay);

        this.tempOverlay_circle = this.mapAPI.createCircle({
          center: lnglat,
          radius: areaData.rangeId,
          strokeColor: areaData.areaColor,
          fillColor: areaData.areaColor
        });
        this.mapAPI.addOverlay(this.tempOverlay_circle);
        this.mapAPI.setCenter(lnglat);
      }
    },
    aLnglatConvert(is02To84) {
      if (is02To84) {
        let llObj_84 = ll02To84(this.aParams.lng02, this.aParams.lat02);
        this.aParams.lng84 = +llObj_84.lng.toFixed(6);
        this.aParams.lat84 = +llObj_84.lat.toFixed(6);
      } else {
        let llObj_02 = ll02To84(this.aParams.lng84, this.aParams.lat84);
        this.aParams.lng02 = +llObj_02.lng.toFixed(6);
        this.aParams.lat02 = +llObj_02.lat.toFixed(6);
      }
    },
    // 当输入框 修改经纬度
    aLngLatChange: _.debounce(function() {
      let ll02 = ll84To02(this.aParams.lng84, this.aParams.lat84);
      this.mapAPI.setPosition(this.marker, ll02.lng + "," + ll02.lat);
      this.mapAPI.setCenter(ll02.lng + "," + ll02.lat);
      this.aMoveCallBack({
        lng: ll02.lng,
        lat: ll02.lat
      });
    }, 500),
    aMoveCallBack(rObj) {
      let lng_old = this.aParams.lng02;
      let lat_old = this.aParams.lat02;
      let lng_new = rObj.lng;
      let lat_new = rObj.lat;
      this.aParams.lng02 = lng_new;
      this.aParams.lat02 = lat_new;
      this.aLnglatConvert(true);
      this.fnGetAddress({
        lng02: lng_new,
        lat02: lat_new
      }).then(add => {
        this.aParams.address = add;
      });
      //处理area相关
      if (this.area != null) {
        let path_old = this.mapAPI.getPath(this.area);
        let llObjArr_old = [];
        path_old.forEach(lnglat => {
          let oLngLat = {
            lng: this.mapAPI.getLng(lnglat),
            lat: this.mapAPI.getLat(lnglat)
          };
          llObjArr_old.push(oLngLat);
        });
        let llObjArr_new = getNewLLByOld({
          lng_old,
          lat_old,
          lng_new,
          lat_new,
          llObjArr_old
        });
        let path_new = [];
        let llObjArr = [];
        llObjArr_new.forEach(llObj => {
          path_new.push(
            this.mapAPI.createLngLat({
              lng02: llObj.lng,
              lat02: llObj.lat
            })
          );
          let llObj_84 = ll02To84(llObj.lng, llObj.lat);
          llObjArr.push({
            lng02: llObj.lng,
            lat02: llObj.lat,
            lng84: llObj_84.lng,
            lat84: llObj_84.lat
          });
        });
        this.aParams.llObjArr = llObjArr.concat();
        this.mapAPI.removeOverlay(this.area);
        this.area = this.mapAPI.createPolygon({
          path: path_new,
          strokeColor: this.aParams.acreageColor,
          fillColor: this.aParams.acreageColor
        });
        this.mapAPI.addOverlay(this.area);
      }
    },
    aAddDragListener() {
      this.mapAPI.addListener_drag(this.marker, rObj => {
        this.aMoveCallBack(rObj);
      });
    },
    fnGetAddress(lnglat) {
      return new Promise(resolve => {
        let llobj84 = ll02To84(lnglat.lng02, lnglat.lat02);
        this.getAddress(llobj84).then(add => {
          resolve(add);
        });
      });
    },
    aLevelChange(level) {
      this.aLevelPopShow = false;
      this.$emit("update:aLevel", level);
      this.$emit("levelChange", "area", level);
    },
    aEyeClick() {
      let IsShow = !this.aEyeShow;
      this.$emit("update:aEyeShow", IsShow);
      this.$emit("eyeChange", "area", IsShow);
    },
    aOpenLayer(opts) {
      this.mapAPI.removeOverlay([this.marker, this.area, this.areaXz]);
      this.closeAllOverLayers();
      Object.assign(this.aParams, opts);
      if (this.aParams.id != 0) {
        this.operType = 1;
      }
      if (this.aXzParams.categoryId == 0) {
        this.aXzParams.categoryId = "";
      }
      this.fenceType = 2;
      this.$refs.orgSelect_area.setSelectList([this.aParams.orgId]);
      this.$refs.areaLayer.showBox();
      //marker
      let lnglat = this.mapAPI.createLngLat({
        lng84: this.aParams.lng84,
        lat84: this.aParams.lat84,
        lng02: this.aParams.lng02,
        lat02: this.aParams.lat02
      });
      this.aParams.lng02 = this.mapAPI.getLng(lnglat);
      this.aParams.lat02 = this.mapAPI.getLat(lnglat);
      this.marker = this.mapAPI.createMarker({
        position: lnglat,
        color: this.aParams.titleColor,
        draggable: true,
        icon: require("e6-base-map/assets/e6Images/logistic/center.png"),
        width: 20,
        height: 20
      });
      this.mapAPI.addOverlay(this.marker);
      this.mapAPI.setTop(this.marker, true);
      this.aAddDragListener();
      this.mapAPI.setCenter(lnglat);
      //area
      let path = [];
      this.aParams.llObjArr.forEach(llObj => {
        path.push(
          this.mapAPI.createLngLat({
            lng84: llObj.lng84 || 0,
            lat84: llObj.lat84 || 0,
            lng02: llObj.lng02 || 0,
            lat02: llObj.lat02 || 0
          })
        );
      });
      this.area = this.mapAPI.createPolygon({
        path: path,
        strokeColor: this.aParams.acreageColor,
        fillColor: this.aParams.acreageColor
      });
      this.mapAPI.addOverlay(this.area);
      //将area放在可视范围之内
      this.mapAPI.setFitView({ overlayList: [this.area] });
    },
    aSaveClick: _.debounce(function() {
      this.$refs.form_area.validate(valid => {
        if (valid) {
          this.$emit("saveOverlay", {
            type: "area",
            operType: this.operType,
            params: this.aParams
          });
          this.clearTempAreas();
        } else {
          return false;
        }
      });
    }, 500),
    aCloseLayer() {
      this.$refs.areaLayer.closeBox();
      this.$refs.orgSelect_area.multipleRemoveAll();
      if (this.operType != 1) {
        this.operType = 0;
        this.fenceType = 0;
      }
      this.mapAPI.removeOverlay([this.marker, this.area, this.areaXz]);
      this.area = null;
      this.marker = null;
      let opts = {
        id: 0,
        name: "",
        titleColor: "#000",
        areaAcreage: 0,
        acreageColor: "#409eff",
        categoryId: "",
        code: "",
        orgId: 0,
        share: 1,
        lng84: 0,
        lat84: 0,
        lng02: 0,
        lat02: 0,
        address: "",
        contact: "",
        telephone: "",
        remark: "",
        llObjArr: [],
        typeId: 1
      };

      Object.assign(opts, this.aParams);
      this.aParams = JSON.parse(JSON.stringify(opts));
      this.resetForm("form_area");
    },
    aRedrawClick(type) {
      this.$refs.areaLayer.closeBox();
      this.mapAPI.removeOverlay([
        this.marker,
        this.circle,
        this.area,
        this.areaXz
      ]);
      this.marker = null;
      this.circle = null;
      this.area = null;
      this.areaXz = null;
      this.openMarkTypeLayer(true, type);
    },
    aChangeColor() {
      if (this.area != null) {
        this.mapAPI.setOptions(this.area, {
          strokeColor: this.aParams.acreageColor,
          fillColor: this.aParams.acreageColor
        });
      }
    },
    aSelectOrg(selArr) {
      if (selArr.length == 0) {
        this.aParams.orgId = 0;
      } else {
        this.aParams.orgId = selArr[0].id;
      }
    },
    // 通过id显示临时的area
    showTempAreaById(areaId) {
      // 需要显示的数据
      const areaData = this.areaDatas.find(v => v.areaId === areaId);
      if (!areaData) {
        // this.$message({
        //   message: "未找到对应的区域",
        //   type: "warning"
        // });
        return false;
      }
      this.clearTempOverlay();
      if (this.aShown) {
        // area 显示着
        let area = this.logisAreas.find(item => {
          return areaId == item.id;
        });
        if (area) {
          // 设置中心
          this.mapAPI.setCenter(
            this.mapAPI.createLngLat({
              lng84: areaData.lonCenter,
              lat84: areaData.latCenter
            })
          );
          this.mapAPI.openInfoWindow(area);
        } else {
          this.addTempArea(areaData);
        }
      } else {
        // area 隐藏
        this.addTempArea(areaData);
      }
      return true;
    },
    // 添加临时的area
    addTempArea(areaData) {
      let llObjArr = [];
      let aLngLatStr = areaData.areaLonlat.split(";");
      aLngLatStr.forEach(lngLatStr => {
        if (lngLatStr != "") {
          let llArr = lngLatStr.split(",");
          llObjArr.push({ lng84: Number(llArr[1]), lat84: Number(llArr[0]) });
        }
      });
      let opts = {
        llObjArr: llObjArr,
        strokeColor: areaData.areaColor,
        fillColor: areaData.areaColor,
        lng84: areaData.lonCenter,
        lat84: areaData.latCenter,
        extData: {
          type: "area",
          mapAuthData: this.mapAuthData,
          id: areaData.areaId
        }
      };
      let areas = this.createAreas([opts]);
      let opts_center = {
        llObj: {
          lng84: areaData.lonCenter || 0,
          lat84: areaData.latCenter || 0
        },
        icon: require("e6-base-map/assets/e6Images/logistic/blank.png"),
        width: 2,
        height: 2,
        label: areaData.areaName,
        color: areaData.titleColor,
        winDetails: this.$parent.getWinInfo_area(areaData),
        extData: {
          mapAuthData: this.mapAuthData,
          type: "marker"
        }
      };
      let center = this.createAreas_center([opts_center]);
      if (areas.length > 0) {
        this.tempOverlay = areas[0];
        this.tempOverlay_marker = [center[0]];
        this.mapAPI.addOverlay(this.tempOverlay);
        this.mapAPI.addOverlay(center);
        this.mapAPI.setFitView({
          overlayList: [this.tempOverlay]
        });
        this.mapAPI.setCenter(this.mapAPI.createLngLat(opts_center.llObj));
      }
    },
    // --------------------------------areaXz 行政区域 ---------------------//
    // 打开行政区域编辑层
    showAreaXzLayer(data = {}) {
      this.closeEditBoxs();
      this.logisShow = false;
      this.$refs.areaXzLayer.showBox();
      this.$refs.orgSelect_xzarea.setSelectList([this.organizations[0].id]);
      if (Object.keys(data) > 0) {
        this.aXzParams = data;
      }
    },
    aXzOpenLayer(opts) {
      this.mapAPI.removeOverlay([this.marker, this.area, this.areaXz]);
      this.closeAllOverLayers();
      Object.assign(this.aXzParams, opts);
      if (this.aXzParams.categoryId == 0) {
        this.aXzParams.categoryId = "";
      }
      if (this.aXzParams.id != 0) {
        this.operType = 1;
      }
      this.fenceType = 2;
      this.$refs.orgSelect_xzarea.setSelectList([this.aXzParams.orgId]);
      this.$refs.areaXzLayer.showBox();
      //marker
      // let lnglat = this.mapAPI.createLngLat({
      //   lng84: this.aXzParams.lng84,
      //   lat84: this.aXzParams.lat84,
      //   lng02: this.aXzParams.lng02,
      //   lat02: this.aXzParams.lat02
      // });
      // this.aXzParams.lng02 = this.mapAPI.getLng(lnglat);
      // this.aXzParams.lat02 = this.mapAPI.getLat(lnglat);
      // this.marker = this.mapAPI.createMarker({
      //   position: lnglat,
      //   color: this.aXzParams.titleColor,
      //   draggable: true,
      //   icon: require("e6-base-map/assets/e6Images/logistic/center.png"),
      //   width: 24,
      //   height: 24
      // });
      // this.mapAPI.addOverlay(this.marker);
      // this.aAddDragListener();
      // this.mapAPI.setCenter(lnglat);
      //area
      let path = [];
      this.aXzParams.llObjArr.forEach(llObj => {
        path.push(
          this.mapAPI.createLngLat({
            lng84: llObj.lng84 || 0,
            lat84: llObj.lat84 || 0,
            lng02: llObj.lng02 || 0,
            lat02: llObj.lat02 || 0
          })
        );
      });
      this.areaXz = this.mapAPI.createPolygon({
        path: path,
        strokeColor: this.aXzParams.acreageColor,
        fillColor: this.aXzParams.acreageColor
      });
      this.mapAPI.addOverlay(this.areaXz);
      //将area放在可视范围之内
      this.mapAPI.setFitView({ overlayList: [this.areaXz] });
    },
    aXzCloseLayer() {
      this.$refs.areaXzLayer.closeBox();
      this.aXzRedrawClick();
      this.aXzParams = {
        id: 0,
        name: "",
        cityName: "",
        titleColor: "#000",
        areaAcreage: 0,
        acreageColor: "#3095fd",
        categoryId: "",
        code: "",
        orgId: 0,
        share: 1,
        lng84: 0,
        lat84: 0,
        lng02: 0,
        lat02: 0,
        address: "",
        contact: "",
        telephone: "",
        remark: "",
        llObjArr: [],
        typeId: 4
      };
      this.resetForm("form_areaXz");
    },
    aXzChangeColor() {
      if (this.areaXz != null) {
        this.mapAPI.setOptions(this.areaXz, {
          strokeColor: this.aXzParams.acreageColor,
          fillColor: this.aXzParams.acreageColor
        });
      }
    },
    aXzSelectOrg(selArr) {
      if (selArr.length == 0) {
        this.aXzParams.orgId = 0;
      } else {
        this.aXzParams.orgId = selArr[0].id;
      }
    },
    aXzRedrawClick() {
      this.mapAPI.removeOverlay([
        this.marker,
        this.circle,
        this.area,
        this.areaXz
      ]);
      this.marker = null;
      this.circle = null;
      this.area = null;
      this.areaXz = null;
    },
    aXzSaveClick: _.debounce(function() {
      this.$refs.form_areaXz.validate(valid => {
        if (valid) {
          this.$emit("saveOverlay", {
            type: "areaXz",
            operType: this.operType,
            params: this.aXzParams
          });
          this.clearTempAreas();
        } else {
          return false;
        }
      });
    }, 500),
    // aXzSaveClick() {
    //   this.$refs.form_areaXz.validate(valid => {
    //     if (valid) {
    //       this.$emit("saveOverlay", {
    //         type: "areaXz",
    //         operType: this.operType,
    //         params: this.aXzParams
    //       });
    //       this.clearTempAreas();
    //     } else {
    //       return false;
    //     }
    //   });
    // },
    // marker的eye控制显隐
    xzEyeClick() {
      let IsShow = !this.xzEyeShow;
      this.$emit("update:xzEyeShow", IsShow);
      this.$emit("eyeChange", "xzarea", IsShow);
    },
    xzShowOrHideByEye() {
      if (!this.mapAPI) return;
      if (this.xzEyeShow) {
        if (!this.aXzShown) {
          this.mapAPI.addOverlay([...this.xzAreas]);
          this.mapAPI.addOverlay([...this.xzAreas_centerMarker]);
          this.aXzShown = true;
        }
      } else {
        if (this.aXzShown) {
          this.mapAPI.removeOverlay([...this.xzAreas]);
          this.mapAPI.removeOverlay([...this.xzAreas_centerMarker]);
          this.mapAPI.closeInfoWindow();
          this.aXzShown = false;
        }
      }
    },
    addXZAreas(data) {
      let areas = this.createAreas(data);
      this.xzAreas = this.xzAreas.concat(areas);
      //创建area的中心点
      let centerDatasArr = [];
      data.forEach(aData => {
        let opts = {
          llObj: {
            lng84: aData.lng84 || 0,
            lat84: aData.lat84 || 0,
            lng02: aData.lng02 || 0,
            lat02: aData.lat02 || 0
          },
          icon: require("e6-base-map/assets/e6Images/logistic/blank.png"),
          width: 2,
          height: 2,
          extData: {
            id: -1,
            mapAuthData: this.mapAuthData,
            type: "marker"
          },
          ...aData
        };
        centerDatasArr.push(opts);
      });
      let centerMarkers = this.createAreas_center(centerDatasArr);
      this.xzAreas_centerMarker = this.xzAreas_centerMarker.concat(
        centerMarkers
      );
      this.xzShowOrHideByEye();
    },
    xzLayerLoader() {},
    xzLayerRemove() {},
    // 选择城市变化
    async xzCitySelect(sel) {
      this.areaXz && this.mapAPI.removeOverlay([this.areaXz]);
      this.areaXz = null;
      let bin = sel.district.bin
        ? sel.district.bin
        : sel.city.bin
        ? sel.city.bin
        : sel.province.bin
        ? sel.province.bin
        : 0;
      if (bin == 0) return;
      let res = await getXzAreaInfoByCity({ bin: bin });
      if (res.code == 1 && res.result) {
        let data = res.result;
        this.aXzParams.cityName =
          sel.province.name + sel.city.name + sel.district.name;
        this.aXzParams.lng84 = data.centerLon;
        this.aXzParams.lat84 = data.centerLat;
        this.aXzParams.areaAcreage = data.areaAcreage;
        this.aXzParams.address = data.nameDetail;
        let aLnglatStr = data.polyline.split(";");
        let llObjArr = [];
        let llArrData = [];
        aLnglatStr.forEach(lnglatStr => {
          if (lnglatStr != "") {
            let llArr = lnglatStr.split(",");
            llArrData.push([Number(llArr[0]), Number(llArr[1])]);
            llObjArr.push({ lng84: Number(llArr[0]), lat84: Number(llArr[1]) });
          }
        });
        this.aXzParams.areaAcreage = getAcreage(llArrData);
        let opts = {
          llObjArr: llObjArr,
          strokeColor: this.aXzParams.acreageColor,
          fillColor: this.aXzParams.acreageColor,
          label: this.aXzParams.name,
          lng84: this.aXzParams.lng84,
          lat84: this.aXzParams.lat84,
          extData: {
            type: "xzarea",
            mapAuthData: this.mapAuthData,
            id: this.aXzParams.id
          }
        };
        this.aXzParams.llObjArr = llObjArr;
        let areas = this.createAreas([opts]);
        if (areas.length > 0) {
          this.areaXz = areas[0];
          this.mapAPI.addOverlay(this.areaXz);
          this.mapAPI.setFitView({
            overlayList: [this.areaXz]
          });
        }
      }
    },
    // 显示临时行政区域
    showTempXzAreaById(xzAreaId) {
      // 需要显示的数据
      const xzAreaData = this.xzAreaDatas.find(v => v.areaId === xzAreaId);
      if (!xzAreaData) {
        this.$message({
          message: "未找到对应的区域",
          type: "warning"
        });
        return false;
      }
      this.clearTempOverlay();
      if (this.aShown) {
        // area 显示着
        let area = this.logisAreas.find(item => {
          return xzAreaData.areaId == item.id;
        });
        if (area) {
          this.mapAPI.setCenter(
            this.mapAPI.createLngLat({
              lng84: xzAreaData.lonCenter,
              lat84: xzAreaData.latCenter
            })
          );
          this.mapAPI.openInfoWindow(area);
        } else {
          this.addTempXzArea(xzAreaData);
        }
      } else {
        // area 隐藏
        this.addTempXzArea(xzAreaData);
      }
    },
    // 添加临时行政区域
    addTempXzArea(xzAreaData) {
      let llObjArr = [];
      let aLnglatStr = xzAreaData.areaLonlat.split(";");
      aLnglatStr.forEach(lnglatStr => {
        if (lnglatStr != "") {
          let llArr = lnglatStr.split(",");
          llObjArr.push({ lng84: Number(llArr[1]), lat84: Number(llArr[0]) });
        }
      });
      let opts = {
        llObjArr: llObjArr,
        strokeColor: xzAreaData.areaColor,
        fillColor: xzAreaData.areaColor,
        lng84: xzAreaData.lonCenter,
        lat84: xzAreaData.latCenter,
        extData: {
          type: "area",
          mapAuthData: this.mapAuthData,
          id: xzAreaData.areaId
        }
      };
      let areas = this.createAreas([opts]);
      let opts_center = {
        llObj: {
          lng84: xzAreaData.lonCenter || 0,
          lat84: xzAreaData.latCenter || 0
        },
        icon: require("e6-base-map/assets/e6Images/logistic/blank.png"),
        width: 2,
        height: 2,
        color: xzAreaData.titleColor,
        label: xzAreaData.areaName,
        winDetails: this.$parent.getWinInfo_area(xzAreaData, 4),
        extData: {
          mapAuthData: this.mapAuthData,
          type: "marker"
        }
      };
      let center = this.createAreas_center([opts_center]);
      if (areas.length > 0) {
        this.tempOverlay = areas[0];
        this.tempOverlay_marker = [center[0]];
        this.mapAPI.addOverlay(this.tempOverlay);
        this.mapAPI.addOverlay(center);
        this.mapAPI.setFitView({
          overlayList: [this.tempOverlay]
        });
        this.mapAPI.setCenter(this.mapAPI.createLngLat(opts_center.llObj));
      }
    },
    // 删除临时覆盖物
    clearTempOverlay() {
      if (this.tempOverlay) {
        this.mapAPI.removeOverlay(this.tempOverlay);
        this.tempOverlay = null;
      }
      if (Array.isArray(this.tempOverlay_marker)) {
        this.mapAPI.closeInfoWindow(this.tempOverlay_marker[0]);
        this.mapAPI.removeOverlay(this.tempOverlay_marker);
        this.tempOverlay_marker = [];
      } else if (this.tempOverlay_marker) {
        this.mapAPI.closeInfoWindow(this.tempOverlay_marker);
        this.mapAPI.removeOverlay(this.tempOverlay_marker);
        this.tempOverlay_marker = [];
      }
      if (this.tempOverlay_circle) {
        this.mapAPI.removeOverlay(this.tempOverlay_circle);
        this.tempOverlay_circle = [];
      }
    },
    //--------------------------------------------------抽稀------------------//
    divideMap() {
      try {
        this.isDevideOver = false;
        // this.divideCenter = this.mapAPI.getCenterllobj();
        let boundsView = this.mapAPI.getViewBounds02();
        boundsView = this.extendedBounds(boundsView, this.GRID_SIZE);
        this.boundsView = boundsView;
        let lonDiff = Math.abs(this.boundsView.ne.lon - this.boundsView.sw.lon);
        let latDiff = Math.abs(this.boundsView.ne.lat - this.boundsView.sw.lat);
        let tempGrid = this.mapAPI.pixelToPoint(this.GRID_SIZE, this.GRID_SIZE);
        this.GRID_SIZE_LL = {
          lon: Math.abs(tempGrid.lon - this.boundsView.sw.lon),
          lat: Math.abs(tempGrid.lat - this.boundsView.ne.lat)
        };
        this.llGridArr.length = 0;
        this.lonNum = Math.ceil(lonDiff / this.GRID_SIZE_LL.lon);
        this.latNum = Math.ceil(latDiff / this.GRID_SIZE_LL.lat);
        for (let i = 0; i < this.lonNum; i++) {
          let minLon =
            parseFloat(this.boundsView.sw.lon) + i * this.GRID_SIZE_LL.lon;
          let maxLon =
            parseFloat(this.boundsView.sw.lon) +
            (i + 1) * this.GRID_SIZE_LL.lon;
          for (let j = 0; j < this.latNum; j++) {
            let minLat =
              parseFloat(this.boundsView.sw.lat) + j * this.GRID_SIZE_LL.lat;
            let maxLat =
              parseFloat(this.boundsView.sw.lat) +
              (j + 1) * this.GRID_SIZE_LL.lat;
            this.llGridArr.push({
              minLon: minLon,
              minLat: minLat,
              maxLon: maxLon,
              maxLat: maxLat,
              cnt: 0
            });
          }
        }
        this.isDevideOver = true;
      } catch (ex) {
        console.log("divideMap", ex);
      }
    },
    extendedBounds(bounds, gridSize) {
      try {
        bounds = this.cutBounds(bounds);
        let pixelNE = this.mapAPI.pointToPixel(bounds.ne);
        let pixelSW = this.mapAPI.pointToPixel(bounds.sw);
        pixelNE.y -= gridSize;
        pixelNE.x += gridSize;
        pixelSW.x -= gridSize;
        pixelSW.y += gridSize;
        let newNE = this.mapAPI.pixelToPoint(pixelNE.x, pixelNE.y);
        let newSW = this.mapAPI.pixelToPoint(pixelSW.x, pixelSW.y);
        let rObj = { ne: newNE, sw: newSW };
        return rObj;
      } catch (ex) {
        console.log("extendedBounds", ex);
      }
    },
    cutBounds(bounds) {
      try {
        let maxX = this.getMinMax(bounds.ne.lon, -180, 180);
        let minX = this.getMinMax(bounds.sw.lon, -180, 180);
        let maxY = this.getMinMax(bounds.ne.lat, -74, 74);
        let minY = this.getMinMax(bounds.sw.lat, -74, 74);
        let rObj = {
          ne: { lon: maxX, lat: maxY },
          sw: { lon: minX, lat: minY }
        };
        return rObj;
      } catch (ex) {
        console.log("cutBounds", ex);
      }
    },
    getMinMax(i, mix, max) {
      try {
        mix && (i = Math.max(i, mix));
        max && (i = Math.min(i, max));
        return i;
      } catch (ex) {
        console.log("getMinMax", ex);
      }
    },
    moveDivideLoad: _.debounce(function() {
      try {
        // let centerLLobj = this.mapAPI.getCenterllobj();
        // if (
        //   this.divideCenter != null &&
        //   (Math.abs(this.divideCenter.lon - centerLLobj.lon) >
        //     this.GRID_SIZE_LL.lon ||
        //     Math.abs(this.divideCenter.lat - centerLLobj.lat) >
        //       this.GRID_SIZE_LL.lat)
        // ) {
        this.divideLoad();
        // }
      } catch (ex) {
        console.log("moveDivideLoad", ex);
      }
    }, 1500),
    //根据点区域的个数设置是否分格显示
    setIsDivide() {
      try {
        let mNum = this.markerDatas != null ? this.markerDatas.length : 0;
        let aNum = this.areaDatas != null ? this.areaDatas.length : 0;
        if (mNum + aNum > this.MAX_NUM) {
          this.isDivideLoad = true;
        } else {
          this.isDivideLoad = false;
        }
      } catch (ex) {
        console.log("setIsDivide", ex);
      }
    },
    divideLoad() {
      try {
        this.setIsDivide();
        this.divideMap();
        // // this.clearMarkers();
        // // this.clearAreas();
        this.divideReloadPLA();
      } catch (ex) {
        console.log("divideLoad", ex);
      }
    },
    divideReloadPLA() {
      try {
        if (!this.isDevideOver) {
          setTimeout(this.divideLoad, 500);
          return;
        }
        this.countMAInBoundsView();
        //加载点
        this.loadMarkers();
        //加载区域
        this.loadAreas();
      } catch (ex) {
        console.log("divideReloadPLA", ex);
      }
    },
    loadMarkers() {
      this.clearMarkers();
      // let isViewLoad = false; //是否按可视范围进行加载（true：计算可视范围并加载；false：全部加载）
      // //不分格抽稀加载或可视范围及分格计算失败，则加载全部
      // if (
      //   !this.isDivideLoad ||
      //   this.boundsView == null ||
      //   this.GRID_SIZE_LL == null
      // ) {
      //   isViewLoad = false;
      // } else {
      //   isViewLoad = true;
      // }
      let markersInview = [];
      for (let i = 0, len = this.markerDatas.length; i < len; i++) {
        if (
          this.markerDatas[i].lonCenter == 0 ||
          this.markerDatas[i].latCenter == 0
        ) {
          continue;
        }
        // if (isViewLoad) {
        let ll02 = ll84To02(
          this.markerDatas[i].lonCenter,
          this.markerDatas[i].latCenter
        );
        //可视范围内加载（else：全部加载（全部加载不用做特殊处理））
        let isLoad = false;
        let zLevel = this.mapAPI.getZoom();
        if (
          zLevel >= this.ALLDIS_LEVEL_OBJ[this.mapType] ||
          this.isViewLoadAll
        ) {
          //可视范围内--全部加载
          if (
            ll02.lng <= this.boundsView.ne.lon &&
            ll02.lng >= this.boundsView.sw.lon &&
            ll02.lat <= this.boundsView.ne.lat &&
            ll02.lat >= this.boundsView.sw.lat
          ) {
            isLoad = true;
          }
        } else {
          //可视范围内--分块抽稀加载
          let lonD = ll02.lng - this.boundsView.sw.lon;
          let latD = ll02.lat - this.boundsView.sw.lat;
          let lonN = Math.floor(lonD / this.GRID_SIZE_LL.lon);
          let latN = Math.floor(latD / this.GRID_SIZE_LL.lat);
          if (
            latN < 0 ||
            latN >= this.latNum ||
            lonN < 0 ||
            lonN >= this.lonNum
          ) {
            continue;
          }
          let llGridNum = this.latNum * lonN + latN;
          if (
            ll02.lng < this.llGridArr[llGridNum].maxLon &&
            ll02.lng > this.llGridArr[llGridNum].minLon &&
            ll02.lat < this.llGridArr[llGridNum].maxLat &&
            ll02.lat > this.llGridArr[llGridNum].minLat &&
            this.llGridArr[llGridNum].cnt < this.POINT_SIZE
          ) {
            isLoad = true;
            this.llGridArr[llGridNum].cnt++;
          }
        }
        if (!isLoad) {
          continue;
        }
        markersInview.push(this.markerDatas[i]);
        // }
      }
      this.$parent.initLogisMarkers(markersInview, true);
    },
    loadAreas() {
      this.clearAreas();
      // let isViewLoad = false; //是否按可视范围进行加载（true：计算可视范围并加载；false：全部加载）
      // //不分格抽稀加载或可视范围及分格计算失败，则加载全部
      // if (
      //   !this.isDivideLoad ||
      //   this.boundsView == null ||
      //   this.GRID_SIZE_LL == null
      // ) {
      //   isViewLoad = false;
      // } else {
      //   isViewLoad = true;
      // }
      let areaInView = [];
      for (let i = 0, len = this.areaDatas.length; i < len; i++) {
        if (
          this.areaDatas[i].areaLonlat == "" &&
          this.areaDatas[i].typeID == 4
        ) {
          continue;
        }
        if (
          this.areaDatas[i].lonCenter == 0 ||
          this.areaDatas[i].latCenter == 0
        ) {
          continue;
        }
        if (this.areaDatas[i].typeID != 4) {
          // if (isViewLoad) {
          let ll02 = ll84To02(
            this.areaDatas[i].lonCenter,
            this.areaDatas[i].latCenter
          );
          let isLoad = false;
          let zLevel = this.mapAPI.getZoom();
          if (
            zLevel >= this.ALLDIS_LEVEL_OBJ[this.mapType] ||
            this.isViewLoadAll
          ) {
            //显示可视范围全部
            if (
              ll02.lng <= this.boundsView.ne.lon &&
              ll02.lng >= this.boundsView.sw.lon &&
              ll02.lat <= this.boundsView.ne.lat &&
              ll02.lat >= this.boundsView.sw.lat
            ) {
              isLoad = true;
            }
          } else {
            //分格加载显示
            let lonD = ll02.lng - this.boundsView.sw.lon;
            let latD = ll02.lat - this.boundsView.sw.lat;
            let lonN = Math.floor(lonD / this.GRID_SIZE_LL.lon);
            let latN = Math.floor(latD / this.GRID_SIZE_LL.lat);
            if (
              latN < 0 ||
              latN >= this.latNum ||
              lonN < 0 ||
              lonN >= this.lonNum
            ) {
              continue;
            }
            let llGridNum = this.latNum * lonN + latN;
            if (
              ll02.lng < this.llGridArr[llGridNum].maxLon &&
              ll02.lng > this.llGridArr[llGridNum].minLon &&
              ll02.lat < this.llGridArr[llGridNum].maxLat &&
              ll02.lat > this.llGridArr[llGridNum].minLat &&
              this.llGridArr[llGridNum].cnt < this.POINT_SIZE
            ) {
              isLoad = true;
              this.llGridArr[llGridNum].cnt++;
            }
          }
          if (!isLoad) {
            continue;
          }
          areaInView.push(this.areaDatas[i]);
          // }
        }
      }
      this.$parent.initLogisAreas(areaInView, true);
    },
    //计算可视范围内的点和区域的数量
    countMAInBoundsView() {
      try {
        //点
        let mCount = 0;
        if (this.markerDatas != null) {
          for (let i = 0, len = this.markerDatas.length; i < len; i++) {
            if (
              this.markerDatas[i].lonCenter == 0 ||
              this.markerDatas[i].latCenter == 0
            ) {
              continue;
            }
            let mLLObj = ll84To02(
              this.markerDatas[i].lonCenter,
              this.markerDatas[i].latCenter
            );
            if (
              mLLObj.lng <= this.boundsView.ne.lon &&
              mLLObj.lng >= this.boundsView.sw.lon &&
              mLLObj.lat <= this.boundsView.ne.lat &&
              mLLObj.lat >= this.boundsView.sw.lat
            ) {
              mCount++;
            }
          }
        }

        //区域
        let aCount = 0;
        if (this.areaDatas != null) {
          for (let i = 0, len = this.areaDatas.length; i < len; i++) {
            if (
              this.areaDatas[i].lonCenter == 0 ||
              this.areaDatas[i].latCenter == 0
            ) {
              continue;
            }
            let aLLObj = ll84To02(
              this.areaDatas[i].lonCenter,
              this.areaDatas[i].latCenter
            );
            if (
              aLLObj.lng <= this.boundsView.ne.lon &&
              aLLObj.lng >= this.boundsView.sw.lon &&
              aLLObj.lat <= this.boundsView.ne.lat &&
              aLLObj.lat >= this.boundsView.sw.lat
            ) {
              aCount++;
            }
          }
        }

        //行政区域
        let xzAreaCount = 0;
        // if (this.xzAreaDatas != null) {
        //   for (let i = 0, len = this.xzAreaDatas.length; i < len; i++) {
        //     if (this.xzAreaDatas[i].lonCenter == 0 || this.xzAreaDatas[i].latCenter == 0 ) { continue; }
        //     let aLLObj = ll84To02(this.xzAreaDatas[i].lonCenter, this.xzAreaDatas[i].latCenter);
        //     if (aLLObj.lon <= this.boundsView.ne.lon && aLLObj.lng >= this.boundsView.sw.lon
        //       && aLLObj.lat <= this.boundsView.ne.lat && aLLObj.lat >= this.boundsView.sw.lat) {
        //       xzAreaCount++;
        //     }
        //   }
        // }
        //根据点区域总数和阈值的关系返回Boolean值
        this.isViewLoadAll = false;
        if (
          aCount < this.MAX_NUM / 2 &&
          mCount + aCount + xzAreaCount <= this.MAX_NUM
        ) {
          this.isViewLoadAll = true;
        }
      } catch (ex) {
        console.log("countMAInBoundsView", ex);
      }
    },
    clearMarkers() {
      this.mapAPI.removeOverlay(this.logisMarkers);
      this.logisMarkers = [];
    },
    clearAreas() {
      this.mapAPI.removeOverlay(this.logisAreas);
      this.logisAreas = [];
      this.mapAPI.removeOverlay(this.logisAreas_centerMarker);
      this.logisAreas_centerMarker = [];
    },
    clearXzAreas() {
      this.mapAPI.removeOverlay(this.xzAreas);
      this.xzAreas = [];
      this.mapAPI.removeOverlay(this.xzAreas_centerMarker);
      this.xzAreas_centerMarker = [];
    },
    //--------------------------------------------------抽稀------------------//
    // 关闭点、区域、行政区域、线路 的编辑层
    closeAllOverLayers() {
      this.mCloseLayer();
      this.aCloseLayer();
      this.aXzCloseLayer();
      // this.lCloseLayer();
    },

    // 删除多个物流marker
    deleteLogisLines(lIdsArr) {
      for (let i = this.logisLines.length - 1; i >= 0; i--) {
        let line = this.logisLines[i];
        if (lIdsArr.indexOf(line.id) > -1) {
          this.mapAPI.removeOverlay(line);
          this.logisLines.splice(i, 1);
        }
      }
    },
    // 增加多个物流line
    addLogisLines(lDatasArr) {
      let lines = this.createLines(lDatasArr);
      this.logisLines = this.logisLines.concat(lines);
    },
    lSelectOrg(selArr) {
      if (selArr.length == 0) {
        this.lParams.orgId = 0;
      } else {
        this.lParams.orgId = selArr[0].id;
      }
    },
    //--------------------------------智能搜索---------------------------------//
    showMore_intelligent(type) {
      this.isMapLoading = false;
      this.clearMoreLayer_intelligent();
      this.intelligent.moreList = this.intelligent.result[type];
      this.intelligent.moreList &&
        this.intelligent.moreList.forEach(item => {
          // let opts = {
          //   position: this.mapAPI.createLngLat({
          //     lng84: item.lng84,
          //     lat84: item.lat84
          //   }),
          //   width: 9,
          //   height: 13,
          //   icon: require("e6-base-map/assets/e6Images/logistic/marker_small.png"),
          //   winDetails: item.winInfo,
          //   offsetType: 1 //0-图标整体中心；1-图标底部中心
          // };
          let opts = {
            position: this.mapAPI.createLngLat({
              lng84: item.lng84,
              lat84: item.lat84
            }),
            width: 28,
            height: 35,
            icon: require("e6-base-map/assets/e6Images/logistic/point.png"),
            label: item.name,
            winDetails: item.winInfo,
            offsetType: 1, //0-图标整体中心；1-图标底部中心
            extData: {
              id: item.id,
              type: type + "_map",
              mapAuthData: this.mapAuthData,
              vData: item
            }
          };
          let marker = this.mapAPI.createMarker(opts);
          this.mapAPI.addOverlay(marker);
          this.intelligent.moreMarkers.push(marker);
        });
      this.mapAPI.setFitView({ overlayList: this.intelligent.moreMarkers });
      this.$refs.moreLayer_intelligent.showBox();
    },
    closeMoreLayer_intelligent() {
      this.clearMoreLayer_intelligent();
      this.$refs.moreLayer_intelligent.closeBox();
      this.closePanel_intelligent();
    },
    clearMoreLayer_intelligent() {
      // this.intelligent.moreType = "";
      this.intelligent.moreList = [];
      this.intelligent.moreMarkers.forEach(item => {
        this.mapAPI.removeOverlay(item);
      });
      this.mapAPI.closeInfoWindow();
      this.intelligent.moreMarkers = [];
    },
    clearMarker_intelligent() {
      this.mapAPI.closeInfoWindow();
      if (this.intelligent.marker != null) {
        this.mapAPI.removeOverlay(this.intelligent.marker);
      }
    },
    // tab 切换
    tabChange() {
      this.clearMarker_intelligent();
      // console.log("intelligentTab", this.$refs.intelligentTab.currentName);
      this.showMore_intelligent(this.$refs.intelligentTab.currentName);
    },
    closePanel_intelligent() {
      this.clearMarker_intelligent();
      this.clearMoreLayer_intelligent();
      this.intelligent = {
        searchTxt: "",
        marker: null,
        moreMarkers: [],
        moreList: [],
        // moreType: "",
        result: {}
      };
    },
    search_intelligent() {
      try {
        this.intelligent.searchTxt = this.intelligent.searchTxt.trim();
        if (this.intelligent.searchTxt != "") {
          // // 查询关键字
          // this.mapAPI.keywordsSearch(this.intelligent.searchTxt).then(res => {
          //   this.intelligent.result["keywords"] = res;
          //   // 因为数据嵌套层次太深，不能触发render函数重新渲染，所以要手动调用强制更新函数重新渲染。
          //   this.$forceUpdate();
          // });
          // 回调父组件查询vehicle和marker，area
          this.isMapLoading = true;
          let center = this.mapAPI.getCenterllobj();
          this.getCenterCity(center).then(res => {
            this.$emit(
              "intelligentSearch",
              this.intelligent.searchTxt,
              res.city || ""
            );
          });
        } else {
          this.$message({
            message: "请先输入要搜索的内容",
            type: "warning"
          });
        }
      } catch (e) {
        this.isMapLoading = false;
        console.log(e);
      }
    },
    searchBack_intelligent(result) {
      // let keywords = this.intelligent.result["keywords"] || {};
      // if (this.intelligent.result["keywords"]) {
      //   this.intelligent.result = {
      //     keywords
      //   };
      // } else {
      //   this.intelligent.result = {};
      // }
      // for (let item in result) {
      //   this.intelligent.result[item] = result[item];
      // }
      if (
        result["vehicle"].length == 0 &&
        result["area"].length == 0 &&
        result["marker"].length == 0 &&
        result["xzarea"].length == 0 &&
        result["keywords"].length == 0
      ) {
        this.$message({
          message: "没有找到数据",
          type: "warning"
        });
        this.isMapLoading = false;
      } else {
        this.intelligent.result = {
          // keywords,
          ...result
        };
        this.showMore_intelligent(this.intelligentShowTabName);
      }
    },
    showDetails_intelligent(type, id) {
      // let oData = this.intelligent.result[type] || null;
      // if (oData) {
      //   let data = oData.find(item => {
      //     return item.id == id;
      //   });
      // }
      this.intelligent.moreMarkers.find(m => {
        if (this.mapAPI.getExtData(m).id == id) {
          this.mapAPI.setFitView({ overlayList: [m] });
          this.mapAPI.openInfoWindow(m);
        }
      });
    },
    showDetails_intelligent_old(type, id) {
      let oData = this.intelligent.result[type] || null;
      if (oData) {
        let data = oData.find(item => {
          return item.id == id;
        });
        if (data) {
          if (this.intelligent.marker != null) {
            this.mapAPI.removeOverlay(this.intelligent.marker);
            this.intelligent.marker = null;
          }

          let opts = {
            position: this.mapAPI.createLngLat({
              lng84: data.lng84,
              lat84: data.lat84
            }),
            width: 28,
            height: 35,
            icon: require("e6-base-map/assets/e6Images/logistic/point.png"),
            label: data.name,
            winDetails: data.winInfo,
            offsetType: 1, //0-图标整体中心；1-图标底部中心
            extData: {
              id: data.id,
              type: type + "_map",
              mapAuthData: this.mapAuthData,
              vData: data
            }
          };
          this.intelligent.marker = this.mapAPI.createMarker(opts);
          this.mapAPI.addOverlay(this.intelligent.marker);
          this.mapAPI.setFitView({ overlayList: [this.intelligent.marker] });
          this.mapAPI.openInfoWindow(this.intelligent.marker);
        }
      }
    },
    // 判断对应的类型是否展示
    intelligentShow(type) {
      return !(
        this.intelligent.result[type] &&
        this.intelligent.result[type].length > 0
      );
    },
    // 全屏
    fullScreenChange() {
      this.$emit("fullScreen");
    },
    // 切换城市
    changeMapCity(sel) {
      if (sel.province.name == "" && sel.city.name == "") return;
      this.map_city = sel.city.name != "" ? sel.city.name : sel.province.name;
      let lnglat = [];
      let level = "";
      if (sel.city.latlng != "") {
        // 切换到市
        lnglat = sel.city.latlng;
        level = "市";
      } else if (sel.province.latlng != "") {
        // 切换到省
        lnglat = sel.province.latlng;
        level = "省";
      }
      let lnglat_str = lnglat.split("@")[1].split("*");
      this.mapAPI.setZoomAndCenter(
        this.mapAPI.getZoomByLevelTxt(level),
        this.mapAPI.createLngLat({
          lng84: lnglat_str[1],
          lat84: lnglat_str[0]
        })
      );
    },
    aEditById(data) {
      this.mapAPI.closeInfoWindow();
      this.aEditClick(
        this.areaDatas.find(m => {
          return m.areaId == data.id;
        })
      );
    },
    //行修改点击事件
    aEditClick(row) {
      let llObjArr = [];
      let aLnglatStr = row.areaLonlat.split(";");
      aLnglatStr.forEach(lnglatStr => {
        if (lnglatStr != "") {
          let llArr = lnglatStr.split(",");
          llObjArr.push({ lng84: Number(llArr[1]), lat84: Number(llArr[0]) });
        }
      });
      row.categoryId = row.categoryId === 0 ? "" : row.categoryId;
      let opts = {
        id: row.areaId,
        name: row.areaName,
        titleColor: row.titleColor || this.aParams.titleColor,
        areaAcreage: row.areaAcreage,
        acreageColor: row.areaColor || this.aParams.acreageColor,
        categoryId: row.categoryId,
        rangeId: row.rangeId,
        orgId: row.orgId,
        share: row.shareMode,
        code: row.areaCode,
        lng84: row.lonCenter,
        lat84: row.latCenter,
        address: row.position,
        contact: row.contact,
        telephone: row.telephone,
        remark: row.remark,
        llObjArr: llObjArr,
        typeId: row.typeId
      };
      if (row.typeId == 3) {
        this.mOpenLayer(opts);
      } else {
        this.aOpenLayer(opts);
      }
      this.mapAPI.scrollWheel(true);
    },
    // 通过id修改行政区域
    xzAreaEditById(data) {
      this.mapAPI.closeInfoWindow();
      this.xzAreaEditClick(
        this.xzAreaDatas.find(m => {
          return m.areaId == data.id;
        })
      );
    },
    // 修改行政区域
    xzAreaEditClick(row) {
      let llObjArr = [];
      let aLnglatStr = row.areaLonlat.split(";");
      aLnglatStr.forEach(lnglatStr => {
        if (lnglatStr != "") {
          let llArr = lnglatStr.split(",");
          llObjArr.push({ lng84: Number(llArr[1]), lat84: Number(llArr[0]) });
        }
      });
      row.categoryId = row.categoryId === 0 ? "" : row.categoryId;
      let opts = {
        id: row.areaId,
        name: row.areaName,
        titleColor: row.titleColor || this.aXzParams.titleColor,
        areaAcreage: row.areaAcreage,
        acreageColor: row.areaColor || this.aXzParams.acreageColor,
        categoryId: row.categoryId,
        orgId: row.orgId,
        share: row.shareMode,
        code: row.areaCode,
        lng84: row.lonCenter,
        lat84: row.latCenter,
        address: row.position,
        contact: row.contact,
        telephone: row.telephone,
        remark: row.remark,
        llObjArr: llObjArr,
        typeId: row.typeId
      };
      if (row.typeId == 4) {
        opts.cityName = row.position;
        // 行政区域
        this.aXzOpenLayer(opts);
      } else {
        this.aOpenLayer(opts);
      }
    },
    // 获取天气信息
    async getWeatherInfo(extData) {
      let res = await this.mapMonitorApi.fetchWeatherByLonLat({
        lon: extData.vData.lon,
        lat: extData.vData.lat
      });
      if (res.code == 1) {
        dealWeather(res.result, extData);
      }
    },
    // 切换地图点击方法
    changeMap(type) {
      // let that = this;
      let zoom = null;
      let center = null;
      if (this.mapAPI) {
        zoom = this.mapAPI.getZoom();
        center = this.mapAPI.getCenterllobj();
        // this.mapType == "mapbar" && removeWinEventListener(); // 移除 信息框中的 鼠标移入和移出  监听事件，以防图吧报错
        this.mapType == "baidu" && this.mapAPI.scrollWheel(false); // 因百度地图的 zoom 鼠标缩放事件会影响其他地图，所以当从百度切换到其他地图时做此特殊处理
        this.beforeMapChange().then(isLo => {
          this.initDatas();
          window.maplet = null;
          this.map = null;
          this.mapAPI = null;
          this.initOrChangeMap(type, center, zoom).then(() => {
            this.mapChanged(isLo);
            this.lShowOrHideByEye();
            // this.mapMoveListener();
          });
        });
      } else {
        center =
          this.centerLonLat != ""
            ? {
                lon: this.centerLonLat.split(",")[1],
                lat: this.centerLonLat.split(",")[0]
              }
            : undefined;
        this.initOrChangeMap(this.mapType, center).then(() => {
          this.changeCityByMap();
          this.lShowOrHideByEye();
        });
      }
    },
    initDatas() {
      this.mapGeoType = "tileLayer";
      this.logisAreas.forEach(a => {
        this.mapAPI.removeOverlay(a);
      });
      this.xzAreas.forEach(a => {
        this.mapAPI.removeOverlay(a);
      });
      this.xzAreas_centerMarker.forEach(a => {
        this.mapAPI.removeOverlay(a);
      });
      this.logisAreas_centerMarker.forEach(a => {
        this.mapAPI.removeOverlay(a);
      });
      this.logisCameras.forEach(a => {
        this.mapAPI.removeOverlay(a);
      });
      this.logisAreas = [];
      this.xzAreas = [];
      this.xzAreas_centerMarker = [];
      this.aXzShown = false;
      this.logisAreas_centerMarker = [];
      this.logisCameras = [];
      this.clearTempAreas();
    },
    clearTempAreas() {
      this.area && this.mapAPI.removeOverlay(this.area);
      this.areaXz && this.mapAPI.removeOverlay(this.areaXz);
      this.tempOverlay && this.mapAPI.removeOverlay(this.tempOverlay);
      this.tempOverlay_marker &&
        this.mapAPI.removeOverlay(this.tempOverlay_marker);
      this.tempOverlay_circle &&
        this.mapAPI.removeOverlay(this.tempOverlay_circle);
      this.tempOverlay.length = 0;
      this.tempOverlay_marker.length = 0;
      this.tempOverlay_circle.length = 0;
      this.area = null;
      this.areaXz = null;
    },
    closeEditBoxs() {
      this.$refs.areaLayer.closeBox();
      this.$refs.areaXzLayer.closeBox();
    },
    // clickOut() {
    //   let evObj = document.createEvent("MouseEvents");
    //   evObj.initMouseEvent("mousedown", true, true, window);
    //   document.body.dispatchEvent(evObj);
    // },
    // 初始化、更改地图
    initOrChangeMap(
      mapType,
      center = { lat: 22.541098, lon: 114.054136 },
      zoom = 10
    ) {
      this.isMapLoading = true;
      return new Promise(resolve => {
        this.isMapChangeBox = false;
        this.mapType = mapType;
        if (mapType == "gaode") {
          initMap("amapContainer", "gaode", center, zoom).then(map => {
            this.$nextTick(() => {
              window.maplet = map;
              this.map = map;
              import("e6-base-map/utils/gaode/gaodeAPI.js").then(module => {
                this.mapAPI = new module.GaodeAPI(this.map);
                // let that = this;
                // this.map.on("click", () => {
                //   that.clickOut();
                // });
                // this.map.on("dblclick", () => {
                //   that.clickOut();
                // });
                // this.map.on("mousemove", () => {
                //   that.clickOut();
                // });
                // this.$emit("init", mapType);
                this.isMapToolBarShow = true;
                this.isMapLoading = false;
                this.mapAPI.addListener_move(this.mapMoveListener);
                this.mapAPI.addListener_zoom(this.mapMoveListener);
                resolve();
              });
            });
          });
        } else if (mapType == "google") {
          initMap("amapContainer", "google", center, zoom).then(map => {
            window.maplet = map;
            this.map = map;
            import("e6-base-map/utils/google/googleAPI.js").then(module => {
              this.mapAPI = new module.GoogleAPI(this.map);
              this.$emit("init", mapType);
              this.isMapToolBarShow = true;
              this.isMapLoading = false;
              this.mapAPI.addListener_move(this.mapMoveListener);
              this.mapAPI.addListener_zoom(this.mapMoveListener);
              resolve();
            });
          });
        } else if (mapType == "mapbar") {
          initMap("amapContainer", "mapbar", center, zoom).then(map => {
            window.maplet = map;
            this.map = map;
            this.map.setIwStdSize(290, 260);
            import("e6-base-map/utils/mapbar/mapbarAPI.js").then(module => {
              this.mapAPI = new module.MapbarAPI(this.map);
              // MEvent.addListener(this.map, "click", this.clickOut);
              // MEvent.addListener(this.map, "mousedown", this.clickOut);
              // MEvent.addListener(this.map, "pan", this.clickOut);
              this.$emit("init", mapType);
              this.isMapToolBarShow = true;
              this.isMapLoading = false;
              this.mapAPI.addListener_move(this.mapMoveListener);
              this.mapAPI.addListener_zoom(this.mapMoveListener);
              resolve();
            });
          });
        } else if (mapType == "baidu") {
          if ((this.$parent.operationalGuide & 16) == 16) {
            // 如果已经选择了不切换
            this.initBDMap("amapContainer", center, zoom).then(() => resolve());
          } else {
            this.$confirm(
              "您好，由于多用户反馈百度地图在使用过程中出现卡顿，响应慢等情况，为提升用户体验，建议您将默认地图切换为高德地图，同时提供谷歌、图吧地图选项。如有疑问，请随时致易流客服热线400-090-1656.",
              "提示",
              {
                distinguishCancelAndClose: true,
                confirmButtonText: "确认切换",
                cancelButtonText: "暂不切换",
                type: "info",
                closeOnClickModal: false,
                closeOnPressEscape: false
              }
            )
              .then(() => {
                this.setMapType_default("gaode");
              })
              .catch(action => {
                if (action === "cancel") {
                  // 暂不切换
                  let newOpr = this.$parent.operationalGuide | 16;
                  this.mapServiceApi.updateOperationalGuide(newOpr);
                }
                this.initBDMap("amapContainer", center, zoom).then(() =>
                  resolve()
                );
              });
          }
        }
      });
    },
    // 初始化百度地图
    initBDMap(div, center, zoom) {
      return new Promise(resolve => {
        initMap("amapContainer", "baidu", center, zoom).then(map => {
          this.$nextTick(() => {
            window.maplet = map;
            this.map = map;
            import("e6-base-map/utils/baidu/baiduAPI.js").then(module => {
              let m = document.createElement("script");
              m.type = "text/javascript";
              m.src =
                "//api.map.baidu.com/library/DrawingManager/1.4/src/DrawingManager_min.js";
              document.head.appendChild(m);
              let n = document.createElement("script");
              n.type = "text/javascript";
              n.src =
                "//api.map.baidu.com/library/DistanceTool/1.2/src/DistanceTool_min.js";
              document.head.appendChild(n);
              let l = document.createElement("script");
              l.type = "text/javascript";
              l.src =
                "//api.map.baidu.com/library/InfoBox/1.2/src/InfoBox_min.js";
              document.head.appendChild(l);
              // 百度原生聚合 文件
              // let t = document.createElement("script");
              // t.type = "text/javascript";
              // t.src =
              //   "//api.map.baidu.com/library/TextIconOverlay/1.2/src/TextIconOverlay_min.js";
              // document.head.appendChild(t);
              // let c = document.createElement("script");
              // c.type = "text/javascript";
              // c.src =
              //   "//api.map.baidu.com/library/MarkerClusterer/1.2/src/MarkerClusterer_min.js";
              // document.head.appendChild(c);

              this.mapAPI = new module.BaiduAPI(this.map);
              this.$emit("init", "baidu");
              this.isMapToolBarShow = true;
              this.isMapLoading = false;
              this.mapAPI.addListener_move(this.mapMoveListener);
              this.mapAPI.addListener_zoom(this.mapMoveListener);
              this.mapAPI.scrollWheel(true);
              // this.map.enableContinuousZoom();
              // new BMapLib.DistanceTool(this.map);
              resolve();
            });
          });
        });
      });
    },
    // 地图移动事件 监听
    mapMoveListener() {
      setTimeout(() => {
        this.changeCityByMap();
      }, 500);
    },
    // 地图缩放 平移 改变中心城市
    changeCityByMap: _.debounce(function() {
      if (this.mapAPI == null) return;
      let zoom = this.mapAPI.getZoom();
      let center = this.mapAPI.getCenterllobj();
      let countryLevel = this.mapAPI.getZoomByLevelTxt("全国");
      if (zoom <= countryLevel) {
        // 直接显示全国
        this.map_city = "全国";
      } else {
        if (this.preMoveCenter == null) {
          this.getCenterCity(center).then(cityObj => {
            cityObj && this.setCityByLevel(zoom, cityObj);
            this.preMoveCenter = center;
          });
        } else {
          //地图中心点移动的距离 >5km再进行请求新数据（0.009 = 1 KM，0.05 = 5km）
          if (
            Math.abs(this.preMoveCenter.lon - center.lon) > 0.1 ||
            Math.abs(this.preMoveCenter.lat - center.lat) > 0.1
          ) {
            this.getCenterCity(center).then(cityObj => {
              cityObj && this.setCityByLevel(zoom, cityObj);
              this.preMoveCenter = center;
            });
          }
        }
      }
    }, 2000),
    // 设置城市
    setCityByLevel(level, cityObj) {
      try {
        let pro = cityObj.province
          .replace("自治区", "")
          .replace("回族自治区", "")
          .replace("维吾尔自治区", "")
          .replace("壮族自治区", "")
          .replace("特别行政区", "")
          .replace("直辖市", "");
        let city = cityObj.city
          .replace("自治区", "")
          .replace("回族自治区", "")
          .replace("维吾尔自治区", "")
          .replace("壮族自治区", "")
          .replace("特别行政区", "")
          .replace("直辖市", "");
        if (
          level > this.mapAPI.getZoomByLevelTxt("全国") &&
          level <= this.mapAPI.getZoomByLevelTxt("省")
        ) {
          // 显示省份
          if (cityObj) {
            this.$nextTick(() => {
              this.map_city = pro == "" ? city : pro;
            });
          }
        } else if (level > this.mapAPI.getZoomByLevelTxt("省")) {
          // 显示市
          if (cityObj) {
            this.$nextTick(() => {
              this.map_city = city;
            });
          }
        }
      } catch (e) {
        console.log(e);
      }
    },
    // 获取城市
    getCenterCity({ lon, lat }) {
      const center = ll02To84(lon, lat);
      return new Promise(async resolve => {
        let result = null;
        let res = await fetchCityByLonLat({
          lon: center.lng.toFixed(6),
          lat: center.lat.toFixed(6)
        });
        // let res = {
        //   code: 1,
        //   message: "OK",
        //   result: {
        //     province: "广东省",
        //     city: "惠州市"
        //   }
        // };
        if (res.code == 1 && res.result) {
          result = res.result;
        }
        resolve(result);
      });
    },
    // 设置默认地图
    setMapType_default(mapType) {
      this.$emit("mapTypeChange", mapType);
    },
    //跳转车辆详情
    goVehicleDetail(data) {
      let menu = this.$parent.getUrlByMenuKey("TMSE6Vehicle");
      if (menu.url == "") return;
      if (menu.type == "jquery") {
        menu.url = `${menu.url}?carID=${data.id}`;
      } else {
        menu.url = `${menu.host}/#/vehicleInfoDetail?vehicleId=${data.id}`;
      }
      window.open(menu.url, "_blank");
    },
    //跳转区域报警设置
    goAreaAlarmSet() {
      let menu = this.$parent.getUrlByMenuKey("AlarmAreaAlarmSetting");
      if (menu.url == "") return;
      window.open(menu.url, "_blank");
    },

    // 初始化高德地图
    initMapCallback() {
      let map = new AMap.Map(this.$refs["amapContainer"], {
        center: [114.054136, 22.541098],
        mapStyle: "amap://styles/5ce7d3607262ad77eab4fc792a4454e3",
        zoom: 10
      });
      AMap.plugin(
        ["AMap.ToolBar", "AMap.MouseTool", "AMap.Scale", "AMap.Geocoder"],
        () => {
          map.addControl(new AMap.ToolBar());
          map.addControl(new AMap.Scale());
        }
      );
      global.map = map;
      window.maplet = map;
      this.map = map;
      import("e6-base-map/utils/gaode/gaodeAPI.js").then(module => {
        this.mapAPI = new module.GaodeAPI(this.map);
        this.isMapToolBarShow = true;
        this.isMapLoading = false;
        this.mapAPI.addListener_move(this.mapMoveListener);
        this.mapAPI.addListener_zoom(this.mapMoveListener);
        this.$emit("init", this.map);
      });
    },
    initGaodeMap() {
      let key = "672a0b0ad3864a331c9e2f2e62e45693";
      let src = `//webapi.amap.com/maps?v=1.4.15&key=${key}&callback=initMapCallback`;
      const $script = document.createElement("script");
      global.document.body.appendChild($script);
      $script.src = src;
    }
  },
  mounted() {
    // this.initOrChangeMap('gaode')
    window.initMapCallback = this.initMapCallback;
    this.initGaodeMap();
    window.getWeatherInfo = this.getWeatherInfo;
    window.aEditById = this.aEditById;
    window.xzAreaEditById = this.xzAreaEditById;
    window.goVehicleDetail = this.goVehicleDetail;
    window.goAreaAlarmSet = this.goAreaAlarmSet;
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/map/theme.scss";
.logisContainer {
  width: 100%;
  height: 100%;
  // .toolsBox {
  //   width: 99%;
  //   font-size: 12px;
  //   height: 37px;
  //   background-color: transparent;
  //   position: absolute;
  //   z-index: 5;
  //   display: flex;
  //   flex-direction: row;
  //   justify-content: space-between;
  //   margin: 5px 0;
  .fr,
  .fl {
    margin: 5px 0;
    position: absolute;
    z-index: 5;
    font-size: 12px;
    height: 37px;
    display: flex;
    align-items: center;
    // height: 100%;
    i {
      font-size: 16px;
      color: $--iconfont-color;
    }
    .tool-span {
      margin-left: 10px;
      padding: 5px 10px;
      height: 22px;
      line-height: 22px;
      background-color: #fff;
      border-radius: 5px;
      box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.3);
      border: 1px solid rgba(0, 0, 0, 0.2);
      display: flex;
      flex-direction: row;
      .disabled {
        cursor: not-allowed !important;
      }
      .split-line {
        height: 22px;
        width: 1px;
        background-color: rgba(0, 0, 0, 0.3);
        margin: 0 8px;
      }
      .full-screen,
      .e6-icon-earth_fill,
      .e6-icon-map_fill {
        font-size: 20px;
        &:hover {
          cursor: pointer;
          color: $--main-color;
        }
      }
      /deep/ .city-div {
        line-height: 22px;
        .search-input::-webkit-input-placeholder {
          color: $--font-color;
        }
        .search-input::-moz-placeholder {
          color: $--font-color;
        }
        .search-input:-ms-input-placeholder {
          color: $--font-color;
        }
        .city-input {
          width: 90px !important;
          border: none;
          background-color: none;
          height: 22px;
          line-height: 22px;
          .select-arrow-b_line {
            display: none;
          }
        }
        .select-text {
          margin-top: 10px;
          color: $--font-color;
        }
      }
    }
    .e6-icon-arrow-b_fill {
      font-size: 12px;
      margin-left: -20px;
      z-index: 2;
    }
    .toolBtn {
      white-space: nowrap;
      color: $--font-color;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      &:hover {
        color: $--main-color;
        i {
          color: $--main-color;
        }
      }
      > i {
        margin-right: 5px;
      }
      .e6-icon-earth_fill {
        margin-right: 0;
      }
      .e6-icon-arrow-b_fill {
        margin-left: 5px;
        font-size: 12px;
        // color: $--font-color;
      }
    }
  }
  .fl {
    // float: left;
    left: 5px;
  }
  .fr {
    // float: right;
    right: 10px;
    .searchBox {
      height: 34px;
      line-height: 34px;
      box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.3);
      border-radius: 4px;
      /deep/ .el-input__inner {
        height: 34px;
        line-height: 34px;
      }
      /deep/ .el-input__suffix {
        margin-right: 5px;
        display: flex;
        align-items: center;
        color: $--main-color;
        font-size: 14px;
        cursor: pointer;
        &:hover {
          i {
            color: $--main-hover-color;
          }
        }
      }
    }
  }
  // }
  .mapContainer {
    width: 100%;
    height: calc(100%);
    // 高德地图样式覆盖
    /deep/ .amap-toolbar {
      top: 50px !important;
      z-index: 4;
    }
    /deep/ .amap-scalecontrol {
      bottom: 5px !important;
    }
    /deep/ .amap-container {
      .amap-logo,
      .amap-copyright {
        visibility: hidden !important;
      }
    }
    /deep/ .amap-overlay-text-container {
      font-size: 12px !important;
    }
    .trafficLayer {
      z-index: 5;
      position: absolute;
      right: 66px;
      top: 50px;
      border-radius: 4px;
      box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.2);
      > i {
        // position: absolute;
        right: 4px;
        top: 4px;
        font-size: 16px;
        color: $--font-color;
        cursor: pointer;
      }
      .trafficTip {
        /deep/ .el-card__body {
          padding: 8px;
          display: flex;
          align-items: center;
          justify-content: space-between;
        }
        label {
          font-size: 12px;
          color: $--font-color;
          margin: 0 3px;
        }
        em {
          width: 20px;
          height: 6px;
          margin: 0 1px;
          text-indent: -9999;
          &.high {
            background-color: #8e0e0b;
          }
          &.red {
            background-color: #f23030;
          }
          &.yellow {
            background-color: #ff9f19;
          }
          &.green {
            background-color: #50bf39;
          }
        }
        i {
          color: $--iconfont-color;
          cursor: pointer;
          font-size: 14px;
          margin: 0 5px;
        }
        .e6-icon-refresh_fill {
          color: $--main-color;
          &:hover {
            color: $--main-hover-color;
          }
        }
      }
    }
    // 图吧地图样式覆盖 31.4
    // /deep/ #LayerControl_in_amapContainer {
    //   top: 48px !important;
    // }
    // /deep/ #ImgCopyright_in_amapContainer {
    //   display: none;
    // }
    // /deep/ #ImgCopyright_in_amapContainer + div {
    //   display: none;
    // }
    // /deep/ .tiplabel {
    //   line-height: 18px;
    //   height: 18px;
    //   padding: 2px 4px;
    //   border-radius: 2px;
    //   border: 1px solid $--color-place;
    //   color: $--font-color;
    //   background-color: $--grayBg-color;
    //   font-weight: 500;
    // }
    // /deep/ #MapContainer_in_amapContainer {
    //   > table {
    //     // border: 2px solid $--grayBg-color !important;
    //     border: transparent !important;
    //     width: 286px !important;
    //     border-radius: 5px;
    //     > tbody {
    //       position: relative;
    //       > tr:first-child {
    //         position: absolute;
    //         z-index: 1;
    //         margin-top: 5px;
    //       }
    //       > tr:last-child {
    //         float: left;
    //         height: 100%;
    //         td > div {
    //           height: 100% !important;
    //           width: 100% !important;
    //           overflow: hidden;
    //           padding: 0 !important;
    //         }
    //       }
    //     }
    //   }
    //   > table ~ div {
    //     width: 286px !important;
    //     border-radius: 5px;
    //   }
    //   > table + div {
    //     width: 23px !important;
    //     // height: 20px !important;
    //     // background-color: $--grayBg-color;
    //     // transform: rotate(45deg);
    //     // div {
    //     //   display: none;
    //     // }
    //   }
    // }
    // 图吧  31.3
    /deep/ #LayerControl {
      top: 48px !important;
    }
    /deep/ #ImgCopyright {
      display: none;
    }
    /deep/ #ImgCopyright + div {
      display: none;
    }
    /deep/ .tiplabel {
      line-height: 18px;
      height: 18px;
      padding: 2px 4px;
      border-radius: 2px;
      border: 1px solid $--color-place;
      color: $--font-color;
      background-color: $--grayBg-color;
      font-weight: 500;
    }
    /deep/ #MapContainer {
      > table {
        // border: 2px solid $--grayBg-color !important;
        border: transparent !important;
        width: 286px !important;
        border-radius: 5px;
        > tbody {
          position: relative;
          > tr:first-child {
            position: absolute;
            z-index: 1;
            margin-top: 5px;
          }
          > tr:last-child {
            float: left;
            height: 100%;
            td > div {
              height: 100% !important;
              width: 100% !important;
              overflow: hidden;
              padding: 0 !important;
            }
          }
        }
      }
      > table ~ div {
        width: 286px !important;
        border-radius: 5px;
      }
      > table + div {
        width: 23px !important;
        // height: 20px !important;
        // background-color: $--grayBg-color;
        // transform: rotate(45deg);
        // div {
        //   display: none;
        // }
      }
    }
    /deep/ .markerSpan {
      display: inline-block;
      background: #fff;
      border-radius: 3px;
      font-size: 12px;
      line-height: 12px !important;
      margin: 0 0 0 2px;
      word-break: keep-all;
      white-space: nowrap;
    }
    /deep/ .markerSpan-show {
      border: 1px solid #cdcdcd;
      padding: 3px;
    }
    // 谷歌地图
    /deep/ .gm-style-mtc {
      width: 80px !important;
      font-size: 12px !important;
      top: 40px !important;
      div {
        font-size: 12px !important;
      }
    }
    /deep/ .mapMarker {
      word-break: keep-all;
      white-space: nowrap;
      img {
        vertical-align: top;
      }
      span {
        vertical-align: middle;
      }
      span {
        display: inline-block;
        border: 1px solid #cdcdcd;
        // padding: 3px !important;
        border-radius: 3px;
        font-size: 12px;
        line-height: 12px !important;
        word-break: keep-all;
        white-space: nowrap;
        background-color: #fff !important;
      }
    }
    /deep/ .gm-style-iw-t {
      &::after {
        background: $--grayBg-color !important;
      }
      .gm-style-iw-c {
        padding: 0 !important;
        max-width: 286px !important;
        max-height: 260px !important;
        height: 260px !important;
        .gm-style-iw-d {
          max-width: 286px !important;
          max-height: 260px !important;
          height: 260px !important;
          overflow: hidden !important;
        }
        > button {
          top: 0 !important;
          right: 0 !important;
        }
      }
    }
    // 百度地图
    /deep/ .infoBox {
      box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.2);
      border: 1px solid rgba(0, 0, 0, 0.15);
      border-radius: 5px;
      user-select: auto !important;
      // > img {
      //   content: url("~e6-base-map/assets/e6Images/close.png");
      //   width: 12px;
      //   height: 12px;
      //   &:hover {
      //     content: url("~e6-base-map/assets/e6Images/closeHover.png");
      //   }
      // }
      .win-arrow {
        display: block;
      }
    }
  }

  // 引导提示 地图类型
  .map-type-tip {
    position: absolute;
    width: 400px;
    height: 90px;
    top: 20px;
    left: 5px;
    z-index: 5;
    font-size: 14px;
    background-image: url("../../../assets/e6Images/tips/maptypeBG.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    .content {
      position: absolute;
      bottom: 22px;
      left: 30px;
      color: $--font-color;
    }
    .close {
      position: absolute;
      bottom: 22px;
      right: 80px;
      color: $--main-color;
      &:hover {
        cursor: pointer;
        color: $--main-hover-color;
      }
    }
  }
  // 引导提示  地图工具
  .tool-tip {
    position: absolute;
    width: 382px;
    height: 100px;
    top: 20px;
    right: 0;
    font-size: 14px;
    background-image: url("../../../assets/e6Images/tips/toolBG.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    .content {
      position: absolute;
      bottom: 22px;
      left: 80px;
      width: 210px;
      color: $--font-color;
    }
    .close {
      position: absolute;
      bottom: 22px;
      right: 30px;
      color: $--main-color;
      &:hover {
        cursor: pointer;
        color: $--main-hover-color;
      }
    }
  }
}
.mapDropdown {
  > ul li {
    padding: 5px 7px;
    font-size: 12px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    > span {
      cursor: pointer;
      &:hover {
        background-color: $--grayBg-color;
        color: $--main-color;
      }
      > i {
        font-size: 14px;
        margin-right: 5px;
        &.a_icon-yanjing,
        &.e6-icon-add_line {
          color: $--main-color;
        }
        &.e6-icon-minus_line {
          color: $--lightgray-font-color;
        }
        &.e6-icon-show_line {
          color: $--main-color;
        }
        &.e6-icon-check_line {
          color: $--monitor_run;
        }
      }
      &.map-set {
        color: $--main-color;
      }
    }
  }
}
.operBox {
  position: absolute;
  top: 20px;
  right: 20px;
  display: flex;
  .searchBox {
    margin-right: 7px;
    position: relative;
    top: -1px;
    > i.e6-icon-search_line {
      font-size: 14px;
    }
    /deep/ .el-input__prefix {
      display: flex;
      align-items: center;
      color: dimgrey;
      font-size: 14px !important;
    }
    /deep/ .el-input__inner {
      border: 0;
    }
  }
}
.logisSubPop {
  margin: 0;
  padding: 0;
  ul {
    margin: 0;
    padding: 2px 10px;
    li {
      line-height: 24px;
      font-size: 12px;
      list-style: none;
      margin: 0;
      cursor: pointer;
      &.active {
        color: $--main-hover-color;
      }
      &:hover {
        background-color: $--grayBg-color;
        color: $--main-hover-color;
      }
    }
  }
}
.cBox {
  z-index: 5;
  background-color: #fff;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.15);
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  > i {
    position: absolute;
    top: 10px;
    right: 10px;
    cursor: pointer;
    &:hover {
      color: cornflowerblue;
    }
  }
  ul {
    margin: 0;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: space-around;
    margin: 10px;
    li {
      list-style: none;
      display: flex;
      flex-direction: column;
      padding: 20px 25px;
      margin: 20px;
      cursor: pointer;
      i {
        font-size: 30px;
        color: #5ca0c4;
      }
      span {
        font-size: 12px;
        color: #444;
        text-align: center;
        margin-top: 5px;
      }
      &:hover {
        i {
          color: lightcoral;
        }
        background-color: #e6f2ff;
      }
    }
  }
}
.editLayer {
  position: absolute;
  top: 48px;
  right: 10px;
  width: 520px;
  height: fit-content;
  background-color: #fff;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.15);
  // border-top: 3px solid #409eff;
  border-radius: 4px;
  z-index: 200;
  &.navigation {
    width: 460px;
    z-index: 201;
    .tContent .formLayer {
      /deep/ .el-form-item {
        width: 350px;
      }
      .midBox {
        max-height: 106px;
        overflow-y: auto;
        width: 100%;
        /deep/ .__view {
          min-height: auto !important;
        }
      }
      img {
        margin-left: 10px;
        cursor: pointer;
      }
      i {
        font-size: 16px;
        cursor: pointer;
        margin-left: 7px;
        color: $--main-color;
        position: absolute;
        top: 4px;
        right: -30px;
        &:hover {
          color: $--main-hover-color;
        }
      }
      /deep/ .el-select {
        width: 230px;
        .el-select-dropdown.el-popper {
          max-width: calc(100% + 50px);

          .el-scrollbar__view.el-select-dropdown__list {
            display: table;
            .el-select-dropdown__item {
              overflow: visible;
            }
          }
        }
      }
    }
  }
  .tContent {
    background-color: #fff;
    padding: 10px 15px;
    .formLayer {
      display: flex;
      flex-wrap: wrap;
      /deep/ .el-form-item {
        width: 50%;
        margin-bottom: 15px;
        font-size: 12px;
      }
      /deep/ .el-form-item__label {
        font-size: 12px;
      }
      .wholeRow {
        width: 100%;
      }
      /deep/ .el-form-item {
        // &.is-success {
        // .sub-selected-val {
        //   border-color: $--green-color;
        // }
        // }
        &.is-error {
          .sub-selected-val {
            border-color: $--red-color;
          }
        }
      }
      /deep/ .city-input {
        width: 406px !important;
      }
      .radius-select {
        width: 145px;
      }
      .radius-label {
        font-size: 12px;
        margin: 0 4px;
        color: $--font-eleUI-color;
      }
    }
    .comTxt {
      width: 40%;
    }
    .lineStyleBox {
      /deep/ .el-form-item__content {
        display: flex;
        align-items: center;
        position: relative;
      }
      .selectLineWidth {
        width: 130px;
        height: 20px;
        display: flex;
        align-items: center;
        span {
          width: 100%;
          display: inline-block;
        }
      }
    }
    /deep/ .base-select .sub-selected-value {
      .sub-selected-val {
        height: 28px;
        line-height: 28px;
        .drop {
          right: 3px;
          color: #c0c4cc;
        }
        .placeholder {
          padding-left: 5px;
        }
        .multiple-selected-item {
          height: 24px;
          line-height: 24px;
          margin-left: 5px;
          .multiple-selected-item-label {
            font-size: 13px;
            color: $--font-eleUI-color;
          }
        }
      }
      .is-active {
        border-color: $--main-hover-color !important;
      }
    }
    /deep/ .city-div {
      .select-text {
        margin-top: 10px;
      }
    }
  }
  .horizontal {
    display: flex;
    align-items: center;
    .colorCol {
      width: 128px !important;
    }
    .el-select {
      width: 193px !important;
    }
  }
  .colorPicker {
    margin-left: 5px;
  }
  .btnBox {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 8px 0;
    background-color: #f8f8f8;
    .btn {
      margin-right: 20px;
      &:last-child {
        margin-right: 0;
      }
    }
  }
}
.commonLayer {
  position: absolute;
  top: 48px;
  left: 10px;
  height: fit-content;
  width: 460px;
  background-color: #fff;
  .comContent {
    padding: 15px;
    .topStat {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin: 0 0 15px;
    }
    /deep/ .el-table tr {
      font-size: 12px;
      th > .cell {
        height: auto;
      }
    }
    /deep/ .el-table__row {
      cursor: pointer;
      td > .cell {
        padding: 0 10px;
      }
      .operCol {
        i {
          font-size: 16px;
          color: $--main-color;
          margin-right: 5px;
          cursor: pointer;
          &:last-child {
            margin-right: 0;
          }
        }
      }
    }
  }
}
.mIconBox {
  position: relative;
  // top: 8px;
}
.mIconPop {
  display: flex;
  flex-wrap: wrap;
  width: 270px;
  img {
    margin: 6px 9px;
    cursor: pointer;
  }
}
.fl {
  float: left;
}
.fr {
  float: right;
}
.cPointer {
  cursor: pointer;
  outline: none;
  padding: 0 2px;
  position: relative;
  top: 2px;
}
.lineWidthPop {
  height: 464px;
  ul {
    li {
      list-style: none;
      width: 158px;
      margin: 15px;
      cursor: pointer;
    }
  }
}
.intelligent {
  position: relative;
  .content {
    position: relative;
    > i {
      position: absolute;
      right: -6px;
      top: -13px;
      font-size: 14px;
      cursor: pointer;
    }
  }
  .eBox {
    margin: 3px 0;
    padding-bottom: 3px;
    border-bottom: 1px solid $--grey-border-color;
    &:last-child {
      border-bottom: 0;
    }
    .top {
      display: flex;
      align-items: center;
      justify-content: space-between;
      h5 {
        margin: 5px 7px;
      }
      i {
        color: $--main-color;
        margin-right: 5px;
        cursor: pointer;
        &:last-child {
          margin-right: 0;
        }
      }
    }
    .content {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      li {
        font-size: 12px;
        padding: 4px 7px;
        width: 72px;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        box-sizing: border-box;
        color: $--main-color;
        cursor: pointer;
      }
    }
  }
}
.intelligentLayer {
  position: absolute;
  width: 460px;
  top: 48px;
  right: 10px;
  left: auto;
  font-size: 12px;
  .intelligent-tab {
    height: 300px;
    border-top: 1px solid $--gray-color;
    /deep/ .el-tabs__item {
      width: 80px;
      padding: 0 10px;
      margin-right: 1px;
      &:hover {
        color: $--main-hover-color;
      }
      &.is-active {
        background-color: $--grayBg-color;
        color: $--main-hover-color;
      }
      &.is-left {
        text-align: left;
      }
    }
    /deep/ .el-tabs__header {
      &.is-left {
        margin-right: 0;
      }
    }
    /deep/ .el-tabs__item {
      height: 36px !important;
      line-height: 36px !important;
      font-size: 12px;
    }
    /deep/ .el-tabs__active-bar {
      width: 4px;
      height: 36px !important;
      line-height: 36px !important;
      left: 0;
      background-color: $--main-hover-color;
    }
    /deep/ .el-tabs__nav-wrap.is-left::after {
      width: 1px;
    }
    .content {
      max-height: 300px;
      overflow-y: auto;
      & > li {
        line-height: 32px;
        border-bottom: 1px solid $--gray-color;
        padding: 0 10px 0 0;
        display: flex;
        &:hover {
          cursor: pointer;
          background-color: $--grayBg-color;
        }
        & > h3 {
          font-style: italic;
          color: $--iconfont-color;
          font-size: 18px;
          width: 40px;
          text-align: center;
          margin-right: 5px;
        }
        .title {
          margin-right: 5px;
          width: 120px;
          text-align: left;
          color: $--main-hover-color;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
        }
        .address {
          width: 200px;
          color: $--font-color;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
        }
      }
    }
    /deep/ .el-tabs__content {
      height: 100%;
      .el-tab-pane {
        height: 100%;
      }
    }
  }
}
.pullRectLayer {
  position: absolute;
  // width: 550px;
  top: 48px;
  right: 10px;
  left: auto;
  z-index: 200;
}
.navigationResultBox {
  .summary {
    padding: 5px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid $--gray-color;
    .points {
      display: flex;
      .lines {
        width: 250px;
        height: 1px;
        margin: auto;
        border-bottom: 1px dashed $--iconfont-color;
        display: flex;
        font-size: 12px;
        span {
          margin: -9px auto;
          width: 64px;
          height: 20px;
          line-height: 20px;
          border-radius: 4px;
          background-color: $--main-hover-color;
          color: #fff;
          text-align: center;
        }
      }
    }
    .content {
      margin-top: 5px;
      width: 100%;
      display: flex;
      flex-direction: row;
      justify-content: space-around;
      font-size: 12px;
      > p,
      .text {
        width: 30%;
        text-align: center;
        line-height: 18px;
      }
      .text {
        color: $--iconfont-color;
        font-style: oblique;
        font-size: 14px;
        p:nth-last-child(1) {
          font-weight: 600;
        }
      }
      .start,
      .end {
        display: flex;
        flex-direction: column;
        .address {
          color: $--right-top-color;
        }
      }
    }
  }
  .subLine {
    max-height: 200px;
    overflow: hidden;
    width: 100%;
    .oneSub {
      padding: 5px;
      cursor: pointer;
      &:hover {
        background-color: $--grayBg-color;
        color: $--main-hover-color;
      }
      border-bottom: 1px solid $--gray-color;
      display: flex;
      align-items: center;
      h3 {
        color: $--num-color;
        font-style: italic;
        font-size: 16px;
        margin: 0 10px;
        width: 30px;
        text-align: center;
      }
      p {
        margin: 5px 0;
        color: $--font-color;
        font-size: 12px;
        color: $--main-color;
      }
    }
  }
  /deep/ .el-scrollbar__wrap {
    max-height: 300px;
    padding-bottom: 17px;
    .el-scrollbar__view {
      width: 100%;
    }
  }
}
.logisSubPop.el-popover {
  min-width: auto !important;
}
.mapDropdown {
  min-width: initial !important;
}

@media screen and (max-height: 850px) {
  .navigationResultBox {
    /deep/ .el-scrollbar__wrap {
      max-height: 140px;
    }
  }
}
</style>
